// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   StudentPortal.css — BragaBJJ Student Dashboard Styles
   Enhanced with KioskMode-inspired glassmorphic design
   ============================================================================ */

:root {
  --portal-primary: #7c3aed;
  --portal-accent: #22d3ee;
  --portal-surface: rgba(15, 23, 42, 0.65);
  --portal-border: rgba(148, 163, 184, 0.2);
  --portal-text: #e2e8f0;
  --portal-muted: #94a3b8;
  --portal-success: #22c55e;
  --portal-warning: #f59e0b;
}

.student-portal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background:
    radial-gradient(120% 120% at 0% 0%, rgba(124, 58, 237, 0.32) 0%, rgba(15, 23, 42, 0.95) 38%),
    radial-gradient(110% 110% at 100% 0%, rgba(34, 211, 238, 0.28) 0%, rgba(15, 23, 42, 0.92) 42%),
    linear-gradient(160deg, #050614 0%, #0b1120 45%, #050614 100%);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  z-index: 50000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: portalFadeIn 0.3s ease-out;
}

.student-portal-overlay::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 25%, rgba(94, 234, 212, 0.12) 0%, transparent 45%),
    radial-gradient(circle at 80% 20%, rgba(129, 140, 248, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 50% 90%, rgba(14, 165, 233, 0.14) 0%, transparent 55%);
  pointer-events: none;
  z-index: 0;
}

.student-portal-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(125, 211, 252, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(124, 58, 237, 0.08) 1px, transparent 1px);
  background-size: 80px 80px;
  pointer-events: none;
  opacity: 0.35;
  z-index: 0;
}

@keyframes portalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.student-portal-container {
  width: 95%;
  max-width: 1200px;
  height: 90vh;
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 24px;
  box-shadow: 0 22px 45px rgba(2, 6, 23, 0.35), 0 1px 0 rgba(255, 255, 255, 0.04) inset;
  backdrop-filter: blur(32px) saturate(170%);
  -webkit-backdrop-filter: blur(32px) saturate(170%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: portalSlideUp 0.4s ease-out;
  position: relative;
  z-index: 1;
}

/* Golden profile styling for Samuel Braga */
.student-portal-container.golden-profile {
  border: 2px solid rgba(255, 215, 0, 0.6);
  box-shadow: 
    0 22px 45px rgba(255, 215, 0, 0.25), 
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 60px rgba(255, 215, 0, 0.2);
  background: 
    radial-gradient(circle at top left, rgba(255, 215, 0, 0.08) 0%, transparent 50%),
    radial-gradient(circle at bottom right, rgba(255, 165, 0, 0.08) 0%, transparent 50%),
    var(--portal-surface);
}

.student-portal-container.golden-profile .portal-header {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 165, 0, 0.1) 100%) !important;
  border-bottom: 1px solid rgba(255, 215, 0, 0.3) !important;
}

.student-portal-container.golden-profile .portal-header h2 {
  background: linear-gradient(135deg, #ffd700 0%, #ffaa00 45%, #ffd700 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  animation: goldenShimmer 3s ease-in-out infinite;
}

@keyframes goldenShimmer {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.3); }
}

.student-portal-container.golden-profile .stat-card {
  border-color: rgba(255, 215, 0, 0.3);
}

.student-portal-container.golden-profile .stat-card:hover {
  border-color: rgba(255, 215, 0, 0.6);
  box-shadow: 0 8px 20px rgba(255, 215, 0, 0.3);
}

/* Golden profile styling for Samuel Braga */
.student-portal-container.golden-profile {
  border: 2px solid rgba(255, 215, 0, 0.6);
  box-shadow: 
    0 22px 45px rgba(255, 215, 0, 0.25), 
    0 1px 0 rgba(255, 255, 255, 0.04) inset,
    0 0 60px rgba(255, 215, 0, 0.2);
  background: 
    radial-gradient(circle at top left, rgba(255, 215, 0, 0.08) 0%, transparent 50%),
    radial-gradient(circle at bottom right, rgba(255, 165, 0, 0.08) 0%, transparent 50%),
    var(--portal-surface);
}

.student-portal-container.golden-profile .portal-header {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 165, 0, 0.1) 100%);
  border-bottom: 1px solid rgba(255, 215, 0, 0.3);
}

.student-portal-container.golden-profile .portal-header h2 {
  background: linear-gradient(135deg, #ffd700 0%, #ffaa00 45%, #ffd700 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: goldenShimmer 3s ease-in-out infinite;
}

@keyframes goldenShimmer {
  0%, 100% { filter: brightness(1); }
  50% { filter: brightness(1.3); }
}

@keyframes portalSlideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Loading & Error States */
.portal-loading,
.portal-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  text-align: center;
  padding: 40px;
  gap: 20px;
}

.error-icon {
  font-size: 80px;
  margin-bottom: 10px;
  animation: errorPulse 2s ease-in-out infinite;
}

@keyframes errorPulse {
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

.error-message {
  font-size: 16px;
  color: #e9e1ff;
  margin: 10px 0;
  max-width: 500px;
}

.wallet-display {
  background: rgba(0, 0, 0, 0.4);
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(162, 89, 247, 0.3);
  margin: 10px 0;
}

.wallet-display code {
  color: #00ccff;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  word-break: break-all;
  background: none;
  padding: 0;
}

.error-instructions {
  background: rgba(162, 89, 247, 0.1);
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(162, 89, 247, 0.2);
  max-width: 500px;
  text-align: left;
}

.error-instructions p {
  margin: 0 0 12px;
  color: #a259f7;
  font-weight: 600;
}

.error-instructions ol {
  margin: 0;
  padding-left: 20px;
  color: #e9e1ff;
}

.error-instructions li {
  margin: 8px 0;
  line-height: 1.6;
}

.btn-primary-portal {
  background: linear-gradient(135deg, #a259f7 0%, #00ccff 100%);
  color: #fff;
  border: none;
  padding: 14px 32px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.btn-primary-portal:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(162, 89, 247, 0.4);
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(162, 89, 247, 0.2);
  border-top-color: #a259f7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.portal-error h2 {
  margin: 0 0 10px;
  color: #e9e1ff;
  font-size: 32px;
}

.portal-error code {
  background: rgba(0, 0, 0, 0.3);
  padding: 8px 12px;
  border-radius: 6px;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 13px;
  color: #00ccff;
  margin: 10px 0;
  display: inline-block;
}

/* Header */
.portal-header {
  padding: 24px 30px;
  background: rgba(15, 23, 42, 0.45);
  border-bottom: 1px solid var(--portal-border);
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
}

.portal-header h2 {
  margin: 0;
  color: var(--portal-text);
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 45%, #f8fafc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.portal-subtitle {
  color: var(--portal-muted);
  font-size: 14px;
  margin: 4px 0 0;
}

/* ============================= */
/* ADMIN BADGE NEON BORDERS */
/* ============================= */
.profile-doctor-green {
  border: 3px solid #00ff88;
  box-shadow:
    0 0 12px rgba(0, 255, 136, 0.8),
    0 0 24px rgba(0, 255, 136, 0.6),
    inset 0 0 12px rgba(0, 255, 136, 0.4);
  border-radius: 16px;
  transition: all 0.3s ease;
}

.profile-baddie {
  border: 3px solid #ff4fd8;
  box-shadow:
    0 0 12px rgba(255, 79, 216, 0.8),
    0 0 24px rgba(255, 79, 216, 0.6),
    inset 0 0 12px rgba(255, 79, 216, 0.4);
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* COACH – GOLDEN GLOW */
/* ============================= */

.profile-coach {
  border: 3px solid #facc15;
  box-shadow:
    0 0 14px rgba(250, 204, 21, 0.95),
    0 0 30px rgba(250, 204, 21, 0.7),
    inset 0 0 16px rgba(250, 204, 21, 0.45);
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* SUPER BADDIE – PINK NEON (INNER + OUTER) */
/* ============================= */

.profile-super-baddie {
  border: 3px solid #ff4fd8;
  box-shadow:
    0 0 14px rgba(255, 79, 216, 0.95),
    0 0 28px rgba(255, 79, 216, 0.7),
    inset 0 0 16px rgba(255, 79, 216, 0.6);
  background: radial-gradient(
    circle at top,
    rgba(255, 79, 216, 0.12),
    rgba(255, 79, 216, 0.02) 60%
  );
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* MASTER CLASS – SILVER BADGE */
/* ============================= */

.profile-master-class {
  border: 3px solid #cfd8dc;
  box-shadow:
    0 0 12px rgba(207, 216, 220, 0.9),
    0 0 24px rgba(207, 216, 220, 0.6),
    inset 0 0 12px rgba(207, 216, 220, 0.5);
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* SUPER STUDENT – BLUE NEON */
/* ============================= */

.profile-super-student {
  border: 3px solid #3b82f6;
  box-shadow:
    0 0 12px rgba(59, 130, 246, 0.9),
    0 0 24px rgba(59, 130, 246, 0.6),
    inset 0 0 12px rgba(59, 130, 246, 0.45);
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* UPCOMING BEAST – CYAN NEON */
/* ============================= */

.profile-upcoming-beast {
  border: 3px solid #22d3ee;
  box-shadow:
    0 0 12px rgba(34, 211, 238, 0.9),
    0 0 24px rgba(34, 211, 238, 0.6),
    inset 0 0 12px rgba(34, 211, 238, 0.45);
  border-radius: 16px;
  transition: all 0.3s ease;
}

/* ============================= */
/* CORE STUDENT – WHITE NEON */
/* ============================= */

.profile-core-student {
  border: 3px solid #ffffff;
  box-shadow:
    0 0 12px rgba(255, 255, 255, 0.95),
    0 0 24px rgba(255, 255, 255, 0.7),
    inset 0 0 14px rgba(255, 255, 255, 0.45);
  border-radius: 16px;
  transition: all 0.3s ease;
}

.admin-badge-supreme {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.9), rgba(34, 211, 238, 0.75));
  color: #fff;
  padding: 8px 16px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  box-shadow: 0 4px 20px rgba(124, 58, 237, 0.5);
  animation: supremePulse 2s ease-in-out infinite;
}

@keyframes supremePulse {
  0%, 100% { box-shadow: 0 4px 20px rgba(255, 215, 0, 0.5); }
  50% { box-shadow: 0 8px 30px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.3); }
}

.admin-student-selector {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: rgba(30, 41, 59, 0.7);
  border-bottom: 1px solid var(--portal-border);
}

.admin-student-selector label {
  color: var(--portal-accent);
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.student-select-dropdown {
  flex: 1 1;
  padding: 10px 16px;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  color: var(--portal-text);
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.student-select-dropdown:hover {
  border-color: var(--portal-primary);
  background: rgba(124, 58, 237, 0.1);
}

.student-select-dropdown:focus {
  outline: none;
  border-color: var(--portal-accent);
  box-shadow: 0 0 20px rgba(34, 211, 238, 0.3);
}

.student-count-badge {
  padding: 6px 14px;
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.student-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #a259f7 0%, #00ccff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 4px 20px rgba(162, 89, 247, 0.4);
  border: 3px solid rgba(255, 255, 255, 0.1);
}

.student-info h2 {
  margin: 0 0 8px;
  color: #e9e1ff;
  font-size: 28px;
  font-weight: 700;
}

.student-belt {
  margin: 4px 0;
  color: #a259f7;
  font-weight: 600;
  font-size: 16px;
}

.student-wallet {
  margin: 4px 0;
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 13px;
  color: #00ccff;
  opacity: 0.9;
}

.portal-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(148, 163, 184, 0.18);
  border: 1px solid var(--portal-border);
  color: var(--portal-text);
  font-size: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.portal-close-btn:hover {
  background: rgba(239, 68, 68, 0.3);
  border-color: rgba(239, 68, 68, 0.5);
  transform: scale(1.05);
}

/* Quick Stats */
.portal-stats {
  padding: 5px 10px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  gap: 13px;
  background: rgba(30, 41, 59, 0.5);
  border-bottom: 1px solid var(--portal-border);
}

.stat-card {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
}

.stat-card:hover {
  background: rgba(124, 58, 237, 0.15);
  border-color: var(--portal-primary);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.2);
}

.stat-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.stat-icon.payment-paid {
  filter: hue-rotate(90deg);
}

.stat-icon.payment-due {
  filter: hue-rotate(30deg);
}

.stat-icon.payment-overdue {
  filter: hue-rotate(0deg);
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: var(--portal-text);
  margin-bottom: 6px;
  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  font-size: 13px;
  color: var(--portal-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Compact desktop override: make quick-stats smaller and denser for desktop screens
   without affecting mobile mode which has its own styles above. */
@media (min-width: 1024px) {
  .student-portal-container .portal-stats {
    padding: 12px 18px;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px;
  }

  .student-portal-container .stat-card {
    padding: 10px 12px;
    border-radius: 10px;
    min-height: 56px;
  }

  .student-portal-container .stat-icon {
    font-size: 22px;
    margin-bottom: 6px;
  }

  .student-portal-container .stat-value {
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 4px;
  }

  .student-portal-container .stat-label {
    font-size: 11px;
    letter-spacing: 0.6px;
  }
}

/* Desktop stat-tabs (compact navigation for quick-stats) */
@media (min-width: 1024px) {
  .stat-tabs-container {
    padding: 8px 18px 6px;
  }
  .stat-tabs {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .stat-tab {
    background: rgba(255,255,255,0.02);
    color: var(--portal-text);
    border: 1px solid rgba(255,255,255,0.04);
    padding: 6px 10px;
    border-radius: 8px;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.14s ease;
  }
  .stat-tab:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }
  .stat-tab.active { background: linear-gradient(90deg,#7c3aed,#22d3ee); color: #fff; border-color: transparent; }
  .stat-tab.show-all { margin-left: auto; background: transparent; border: 1px solid var(--portal-border); }

  /* Emphasize the active stat and de-emphasize others when a tab is selected */
  .student-portal-container .stat-card.stat-active {
    transform: scale(1.04);
    padding: 12px 14px;
    box-shadow: 0 10px 30px rgba(124,58,237,0.12);
  }
  .student-portal-container .stat-card.stat-dim {
    opacity: 0.45;
    transform: scale(0.96);
  }
}

/* Tabs */
.portal-tabs {
  display: flex;
  gap: 8px;
  padding: 16px 30px;
  background: rgba(15, 23, 42, 0.45);
  border-bottom: 1px solid var(--portal-border);
  overflow-x: auto;
}

.portal-tabs .tab {
  padding: 10px 20px;
  background: transparent;
  border: 1px solid var(--portal-border);
  border-radius: 8px;
  color: var(--portal-muted);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
}

.portal-tabs .tab:hover {
  background: rgba(124, 58, 237, 0.15);
  border-color: var(--portal-primary);
  color: var(--portal-text);
}

.portal-tabs .tab.active {
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));
  border-color: transparent;
  color: #fff;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.portal-tabs .tab .badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #ff4444;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* Content Area */
.portal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 30px;
}

.tab-panel {
  animation: tabFadeIn 0.3s ease-out;
}

@keyframes tabFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-panel h3 {
  margin: 0 0 24px;
  color: var(--portal-text);
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 45%, #f8fafc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Profile Grid */
.profile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.profile-field {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 10px;
  padding: 16px;
  backdrop-filter: blur(8px);
}

.profile-field.full-width {
  grid-column: 1 / -1;
}

.profile-field label {
  display: block;
  font-size: 12px;
  color: var(--portal-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.field-value {
  color: var(--portal-text);
  font-size: 16px;
  font-weight: 500;
}

.field-value.mono {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  color: var(--portal-accent);
  word-break: break-all;
}

.belt-badge {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));
  border-radius: 20px;
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
}

/* Attendance */
.attendance-summary {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  backdrop-filter: blur(8px);
}

.attendance-summary p {
  margin: 8px 0;
  color: var(--portal-text);
}

.attendance-summary strong {
  color: var(--portal-primary);
  font-weight: 700;
}

.attendance-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 500px;
  overflow-y: auto;
}

.attendance-item {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid var(--portal-border);
  border-radius: 10px;
  padding: 16px;
  transition: all 0.2s ease;
}

.attendance-item:hover {
  background: rgba(124, 58, 237, 0.12);
  border-color: var(--portal-primary);
}

.attendance-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--portal-accent) 0%, var(--portal-primary) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  font-weight: 700;
}

.attendance-details {
  flex: 1 1;
}

.attendance-date {
  color: var(--portal-text);
  font-weight: 600;
  margin-bottom: 4px;
}

.attendance-time {
  color: var(--portal-muted);
  font-size: 13px;
}

/* Belt Progression */
.belt-journey {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 30px;
}

.belt-stage {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  position: relative;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
}

.belt-stage.completed {
  background: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3);
}

.belt-stage.current {
  background: rgba(124, 58, 237, 0.15);
  border-color: var(--portal-primary);
  box-shadow: 0 4px 20px rgba(124, 58, 237, 0.2);
}

.belt-stage.future {
  opacity: 0.4;
}

.belt-name {
  flex: 1 1;
  color: var(--portal-text);
  font-size: 18px;
  font-weight: 600;
}

.belt-current-badge {
  padding: 6px 12px;
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
}

.belt-info {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 20px;
  backdrop-filter: blur(8px);
}

.belt-info h4 {
  margin: 0 0 12px;
  color: var(--portal-text);
  font-size: 18px;
}

.belt-info p {
  margin: 8px 0;
  color: var(--portal-text);
}

.belt-info strong {
  color: var(--portal-primary);
}

/* Awards */
.awards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.award-card {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(8px);
}

.award-card:hover {
  background: rgba(124, 58, 237, 0.15);
  border-color: var(--portal-primary);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(124, 58, 237, 0.3);
}

.award-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.award-title {
  color: var(--portal-text);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.award-desc {
  color: var(--portal-muted);
  font-size: 13px;
}

/* Payments */
.payment-status-card {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin-bottom: 24px;
  backdrop-filter: blur(8px);
}

.payment-details p {
  margin: 8px 0;
  color: var(--portal-text);
}

.payment-details strong {
  color: var(--portal-primary);
}

.payment-reminder {
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid var(--portal-primary);
  border-radius: 12px;
  padding: 20px;
  backdrop-filter: blur(8px);
}

.payment-reminder h4 {
  margin: 0 0 12px;
  color: var(--portal-text);
}

.payment-reminder p {
  margin: 8px 0;
  color: var(--portal-text);
}

/* Payments */
.payment-status-card {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin-bottom: 24px;
}

.payment-badge {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}

.payment-badge.payment-paid {
  background: linear-gradient(135deg, #00c853 0%, #00e676 100%);
  color: #fff;
}

.payment-badge.payment-due {
  background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);
  /* ensure readable text on the orange gradient */
  color: var(--portal-text);
}

.payment-badge.payment-overdue {
  background: linear-gradient(135deg, #d32f2f 0%, #f44336 100%);
  color: #fff;
}

.payment-details p {
  margin: 8px 0;
  color: rgba(255, 255, 255, 0.9);
}

.payment-details strong {
  color: #a259f7;
}

.payment-reminder {
  background: rgba(162, 89, 247, 0.1);
  border: 1px solid rgba(162, 89, 247, 0.3);
  border-radius: 12px;
  padding: 20px;
}

.payment-reminder h4 {
  margin: 0 0 12px;
  color: #e9e1ff;
}

.payment-reminder p {
  margin: 8px 0;
  color: rgba(255, 255, 255, 0.9);
}

/* Messages */
.messages-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: calc(90vh - 400px);
  min-height: 400px;
}

.messages-list {
  flex: 1 1;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  backdrop-filter: blur(8px);
}

.message-item {
  padding: 16px;
  border-radius: 12px;
  animation: messageFadeIn 0.3s ease-out;
}

@keyframes messageFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-item.from-admin {
  background: rgba(124, 58, 237, 0.2);
  border: 1px solid var(--portal-primary);
  align-self: flex-start;
  max-width: 80%;
}

.message-item.from-student {
  background: rgba(34, 211, 238, 0.2);
  border: 1px solid var(--portal-accent);
  align-self: flex-end;
  max-width: 80%;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.message-header strong {
  color: var(--portal-text);
  font-size: 14px;
}

.message-time {
  font-size: 11px;
  color: var(--portal-muted);
}

.message-body {
  color: var(--portal-text);
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.message-compose {
  display: flex;
  gap: 12px;
  padding: 20px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  backdrop-filter: blur(8px);
}

.message-compose textarea {
  flex: 1 1;
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid var(--portal-border);
  border-radius: 8px;
  padding: 12px;
  color: var(--portal-text);
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  min-height: 80px;
}

.message-compose textarea:focus {
  outline: none;
  border-color: var(--portal-primary);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.message-compose .btn-primary {
  padding: 12px 24px;
  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));
  border: none;
  border-radius: 8px;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.message-compose .btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.4);
}

.message-compose .btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Flowchart Styles */
.flowchart-view-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.view-tab {
  padding: 10px 20px;
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.view-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--portal-accent);
}

.view-tab.active {
  background: var(--portal-accent);
  border-color: var(--portal-accent);
  box-shadow: 0 0 12px rgba(124, 58, 237, 0.4);
}

.edit-controls {
  margin-left: auto;
  display: flex;
  gap: 8px;
}

.btn-edit {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.5);
}

.btn-edit:hover {
  background: rgba(59, 130, 246, 0.4);
  border-color: rgba(59, 130, 246, 0.8);
}

.btn-success {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.5);
}

.btn-success:hover {
  background: rgba(34, 197, 94, 0.4);
  border-color: rgba(34, 197, 94, 0.8);
}

.btn-cancel {
  background: rgba(156, 163, 175, 0.2);
  border-color: rgba(156, 163, 175, 0.5);
}

.btn-cancel:hover {
  background: rgba(156, 163, 175, 0.4);
  border-color: rgba(156, 163, 175, 0.8);
}

.flowchart-info {
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  color: var(--portal-muted);
  font-size: 14px;
}

.flowchart-toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.flowchart-toolbar .btn-sm {
  padding: 8px 16px;
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 8px;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.flowchart-toolbar .btn-sm:hover {
  background: var(--portal-accent);
  border-color: var(--portal-accent);
  transform: translateY(-2px);
}

/* General small button hover/active/selected states */
.btn-sm {
  transition: transform 0.14s ease, box-shadow 0.14s ease, background 0.14s ease;
}
.btn-sm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(124,58,237,0.08);
}
.btn-sm:active {
  transform: translateY(0);
  box-shadow: none;
}
.btn-sm.active,
.btn-sm.selected {
  background: linear-gradient(90deg,#7c3aed,#22d3ee);
  color: #fff;
  border-color: rgba(124,58,237,0.28);
  box-shadow: 0 8px 26px rgba(124,58,237,0.16);
}

/* Small extra-button styles (xs) */
.btn-xs:hover { transform: translateY(-1px); }
.btn-xs.active { background: var(--portal-accent); border-color: var(--portal-accent); }

/* View tabs - make hover/tap clearer on mobile */
.view-tab:hover { transform: translateY(-2px); }
.view-tab:active { transform: translateY(0); }
.view-tab.active { box-shadow: 0 12px 36px rgba(124,58,237,0.12); }

/* Color swatch buttons */
.color-swatch {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.12);
  padding: 0;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, border 0.12s ease;
}
.color-swatch:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }
.color-swatch:active { transform: translateY(0); box-shadow: none; }
.color-swatch.selected { border: 2px solid rgba(255,255,255,0.95); box-shadow: 0 10px 28px rgba(255,255,255,0.06) inset; }

/* Make swatches larger and touch-friendly on mobile */
.student-portal-container.mobile-mode .color-swatch { width: 36px; height: 36px; border-radius: 8px; }

/* Improve tap highlight and touch experience */
button { -webkit-tap-highlight-color: rgba(0,0,0,0); }


.flowchart-toolbar .btn-danger {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.5);
  margin-left: auto;
}

.flowchart-toolbar .btn-danger:hover {
  background: rgba(239, 68, 68, 0.4);
  border-color: rgba(239, 68, 68, 0.8);
}

.flowchart-canvas {
  width: 100%;
  height: 500px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  margin-bottom: 20px;
  -webkit-user-select: none;
          user-select: none;
}

.flowchart-node {
  cursor: grab;
  transition: all 0.2s;
}

.flowchart-node:active {
  cursor: grabbing;
}

.flowchart-node.selected rect {
  filter: drop-shadow(0 0 8px rgba(251, 191, 36, 0.6));
}

.flowchart-node rect {
  transition: all 0.2s;
}

.flowchart-node:hover rect {
  filter: brightness(1.2);
}

.flowchart-editor {
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.flowchart-editor h4 {
  margin: 0 0 16px 0;
  color: white;
  font-size: 16px;
}

.editor-field {
  margin-bottom: 16px;
}

.editor-field label {
  display: block;
  color: var(--portal-muted);
  font-size: 13px;
  margin-bottom: 6px;
}

.editor-field input {
  width: 100%;
  padding: 10px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--portal-border);
  border-radius: 8px;
  color: white;
  font-size: 14px;
}

.editor-field input:focus {
  outline: none;
  border-color: var(--portal-accent);
  background: rgba(0, 0, 0, 0.5);
}

.type-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.type-badge.guard {
  background: rgba(59, 130, 246, 0.3);
  border: 1px solid rgba(59, 130, 246, 0.5);
}

.type-badge.pass {
  background: rgba(168, 85, 247, 0.3);
  border: 1px solid rgba(168, 85, 247, 0.5);
}

.type-badge.takedown {
  background: rgba(34, 197, 94, 0.3);
  border: 1px solid rgba(34, 197, 94, 0.5);
}

.type-badge.submission {
  background: rgba(239, 68, 68, 0.3);
  border: 1px solid rgba(239, 68, 68, 0.5);
}

.connect-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.btn-xs {
  padding: 4px 10px;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid var(--portal-border);
  border-radius: 6px;
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-xs:hover {
  background: var(--portal-surface);
  border-color: var(--portal-accent);
}

.btn-xs.active {
  background: var(--portal-accent);
  border-color: var(--portal-accent);
}

.flowchart-legend {
  display: flex;
  gap: 20px;
  padding: 16px;
  background: var(--portal-surface);
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--portal-muted);
  font-size: 13px;
}

.legend-color {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Empty State */
.empty-state {
  text-align: center;
  color: var(--portal-muted);
  font-size: 15px;
  padding: 40px;
}

/* ============================================================================
   MOBILE OPTIMIZATIONS
   Enhanced responsive design for optimal mobile experience
   ============================================================================ */

/* Mobile Mode Specific Styles */
.student-portal-container.mobile-mode {
  width: 100% !important;
  height: 100vh !important;
  max-height: 100vh !important;
  border-radius: 0 !important;
  overflow-y: auto;
}

.student-portal-container.mobile-mode .portal-header {
  padding: 14px 18px;
  position: sticky;
  top: 0;
  z-index: 100;
  /* frosted glass header */
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border-bottom: 1px solid rgba(255,255,255,0.04);
  backdrop-filter: blur(22px) saturate(150%);
}

.student-portal-container.mobile-mode .portal-header h2 {
  font-size: 22px;
}

.student-portal-container.mobile-mode .portal-subtitle {
  font-size: 12px;
}

.student-portal-container.mobile-mode .portal-close-btn {
  width: 40px;
  height: 40px;
  font-size: 28px;
  top: 12px;
  left: 12px; /* move close to left on mobile to avoid overlapping the wallet indicator */
  right: auto;
  z-index: 1300;
}

/* Mobile Stats - Compact 3-column grid for smaller size */
.student-portal-container.mobile-mode .portal-stats {
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 8px 12px;
}

.student-portal-container.mobile-mode .stat-card {
  padding: 8px 6px;
  /* glass surface for stat cards */
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border: 1px solid rgba(255,255,255,0.05);
  box-shadow: 0 4px 12px rgba(2,6,23,0.25);
}

.student-portal-container.mobile-mode .stat-icon {
  font-size: 20px;
  margin-bottom: 3px;
  filter: drop-shadow(0 2px 8px rgba(124,58,237,0.1));
}

.student-portal-container.mobile-mode .stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #f8fbff;
  margin-bottom: 2px;
}

.student-portal-container.mobile-mode .stat-label {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

/* Mobile Tabs - Horizontal scroll with better touch */
.student-portal-container.mobile-mode .portal-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: 0 16px;
  gap: 8px;
}

.student-portal-container.mobile-mode .portal-tabs::-webkit-scrollbar {
  display: none;
}

.student-portal-container.mobile-mode .portal-tab {
  padding: 12px 20px;
  font-size: 13px;
  white-space: nowrap;
  min-width: auto;
  flex-shrink: 0;
}

/* Mobile Content Area */
.student-portal-container.mobile-mode .portal-content {
  padding: 12px;
  background: linear-gradient(180deg, rgba(6,8,15,0.02), rgba(6,8,15,0.04));
}
.student-portal-container.mobile-mode .profile-grid {
  grid-template-columns: 1fr;
  gap: 16px;
}

.student-portal-container.mobile-mode .student-info h2 {
  font-size: 20px;
}

.student-portal-container.mobile-mode .student-avatar {
  width: 70px;
  height: 70px;
  font-size: 32px;
}

/* Mobile Admin Selector - Stack vertically */
.student-portal-container.mobile-mode .admin-student-selector {
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding: 12px 16px;
}

.student-portal-container.mobile-mode .student-select-dropdown {
  width: 100%;
  font-size: 14px;
}

.student-portal-container.mobile-mode .student-count-badge {
  align-self: flex-start;
  font-size: 12px;
}

.student-portal-container.mobile-mode .admin-badge-supreme {
  font-size: 12px;
  padding: 6px 12px;
}

/* Mobile Awards Grid - 2 columns */
.student-portal-container.mobile-mode .awards-grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.student-portal-container.mobile-mode .award-card {
  padding: 12px;
}

/* Mobile Messages - Better touch targets */
.student-portal-container.mobile-mode .message-item {
  max-width: 85% !important;
  padding: 12px 14px;
  font-size: 14px;
}

.student-portal-container.mobile-mode .message-timestamp {
  font-size: 11px;
}

.student-portal-container.mobile-mode .message-input-row {
  gap: 8px;
  padding: 12px;
}

.student-portal-container.mobile-mode .message-input {
  font-size: 14px;
  padding: 12px 14px;
}

.student-portal-container.mobile-mode .send-button {
  width: 44px;
  height: 44px;
  font-size: 18px;
}

/* Mobile Belt Progression - Responsive */
.student-portal-container.mobile-mode .belt-progression {
  gap: 8px;
}

.student-portal-container.mobile-mode .belt-step {
  min-width: 50px;
}

/* Mobile Flowchart - Simplified view */
.student-portal-container.mobile-mode .flowchart-section {
  padding: 12px;
}

.student-portal-container.mobile-mode .flowchart-controls {
  flex-direction: column;
  gap: 12px;
}

.student-portal-container.mobile-mode .flowchart-svg {
  min-height: 400px;
}

/* Mobile Payment Status - Compact */
.student-portal-container.mobile-mode .payment-status-card {
  padding: 16px;
}

.student-portal-container.mobile-mode .payment-status-card h3 {
  font-size: 16px;
}

/* Mobile Store Items - Single column */
.student-portal-container.mobile-mode .store-grid {
  grid-template-columns: 1fr;
  gap: 16px;
}

.student-portal-container.mobile-mode .store-item {
  padding: 16px;
}

/* Mobile Buttons - Larger touch targets */
.student-portal-container.mobile-mode button:not(.portal-close-btn):not(.send-button) {
  min-height: 40px;
  padding: 10px 14px;
  font-size: 13px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border: 1px solid rgba(255,255,255,0.04);
  color: var(--portal-text);
}

/* Mobile header action buttons (Confirm Wallet / Open Portal / Main Menu) - match portal primary style */
.student-portal-container.mobile-mode .mobile-header-actions .btn-sm,
.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button {
  background: linear-gradient(135deg, rgba(124,58,237,0.95) 0%, rgba(34,211,238,0.9) 100%);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.06);
  padding: 8px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.22s ease;
  box-shadow: 0 8px 26px rgba(34, 211, 238, 0.12);
  backdrop-filter: blur(6px);
}

/* Make the header wallet button explicitly green/red on mobile when connected/disconnected */
.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button.connected {
  background: linear-gradient(135deg,#10b981,#34d399) !important;
  border-color: rgba(16,185,129,0.12) !important;
  box-shadow: 0 10px 28px rgba(16,185,129,0.12) !important;
}
.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button.disconnected {
  background: linear-gradient(135deg,#ef4444,#fb923c) !important;
  border-color: rgba(239,68,68,0.12) !important;
  box-shadow: 0 10px 28px rgba(239,68,68,0.10) !important;
}

.student-portal-container.mobile-mode .mobile-header-actions .btn-sm:hover,
.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 36px rgba(124, 58, 237, 0.24);
}

/* Compact small button utility for mobile */
.student-portal-container.mobile-mode .btn-sm {
  padding: 8px 10px;
  font-size: 13px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.015), rgba(255,255,255,0.01));
  border: 1px solid rgba(255,255,255,0.04);
}

/* Embedded store container in StudentPortal (desktop) */
.store-embedded {
  max-height: 520px;
  overflow-y: auto;
  padding: 8px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border: 1px solid rgba(255,255,255,0.04);
}

/* Modal used by StudentPortal to host StoreOrder on mobile */
.cc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2,6,23,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Raised to sit above portal floating UI and other lower overlays */
  z-index: 60010;
}
.cc-modal {
  width: 100%;
  max-width: 980px;
  max-height: 88vh;
  overflow: auto;
  border-radius: 12px;
  padding: 12px;
  background: rgba(8,10,18,0.98);
  box-shadow: 0 18px 60px rgba(2,6,23,0.8);
}

/* Mobile bottom action bar - sticky, compact */
.student-portal-container.mobile-mode .mobile-bottom-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(6,8,15,0.04));
  border-top: 1px solid rgba(255,255,255,0.05);
  box-shadow: 0 -8px 20px rgba(2,6,23,0.6) inset;
  backdrop-filter: blur(12px) saturate(130%);
  z-index: 120;
}

/* Mobile Payments - components moved from inline styles to CSS classes */
.mobile-subtab-btn {
  min-width: 110px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(255,255,255,0.03);
  color: #cbd5e1;
  border: none;
  cursor: pointer;
  font-weight: 700;
}
.mobile-subtab-btn.active {
  background: linear-gradient(90deg,#7c3aed,#22d3ee);
  color: #fff;
  box-shadow: 0 6px 18px rgba(124,58,237,0.12);
}
.mobile-eth-row {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: var(--portal-muted);
}
.mobile-plan-cards {
  margin-top: 12px;
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}
.mobile-plan-card {
  min-width: 220px;
  border-radius: 12px;
  padding: 12px;
  background: #071322;
  color: #e6eef8;
  transition: all 0.18s ease;
  box-shadow: none;
}
.mobile-plan-card.selected {
  background: linear-gradient(180deg,#0f172a,#111827);
  box-shadow: 0 6px 18px rgba(124,58,237,0.18);
}
.mobile-plan-card .plan-price { font-size: 18px; font-weight: 900; }
.mobile-custom-card { min-width: 220px; border-radius: 12px; padding: 12px; background: #071322; color: #e6eef8; }

.mobile-sticky-paybar {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 14px;
  display: flex;
  gap: 8px;
  align-items: center;
  z-index: 9999;
}

.mobile-pay-confirm {
  max-width: 520px;
  margin: auto;
  /* convert to a centered modal by default; use the lightweight overlay below when opening */
  position: relative;
  border-radius: 12px;
  padding: 16px;
  background: rgba(8,10,18,0.98);
  box-shadow: 0 18px 60px rgba(2,6,23,0.8);
}
.mobile-pay-confirm .modal-close { background: transparent; border: none; color: var(--portal-text); font-size: 20px; cursor: pointer; }

/* Lightweight overlay for centering mobile pay confirmation windows */
.mobile-pay-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  z-index: 60020; /* above cc-modal-overlay and wallet-floating */
}

/* Mobile confirm modal - enhanced layout */
.mobile-pay-confirm .confirm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobile-pay-confirm .confirm-subtitle {
  font-size: 13px;
  color: var(--portal-muted);
  margin-top: 6px;
}
.mobile-pay-confirm .wallet-row {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.mobile-pay-confirm .wallet-row .wallet-badge {
  background: rgba(255,255,255,0.03);
  padding: 6px 10px;
  border-radius: 8px;
  font-family: monospace;
  /* ensure high contrast text on varied backgrounds */
  color: var(--portal-text);
}
.mobile-pay-confirm .confirm-amount {
  margin-top: 12px;
  text-align: left;
}
.mobile-pay-confirm .confirm-amount .amount-value {
  font-size: 20px;
  font-weight: 900;
}
.mobile-pay-confirm .confirm-amount .amount-sub {
  font-size: 13px;
  color: var(--portal-muted);
  margin-top: 6px;
}
.mobile-pay-confirm .confirm-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}
.mobile-pay-confirm .btn-spinner {
  position: relative;
}
.mobile-pay-confirm .btn-spinner.processing::after {
  content: '';
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.2);
  border-top-color: #fff;
  display: inline-block;
  margin-left: 8px;
  animation: spin 1s linear infinite;
  vertical-align: middle;
}
@keyframes spin { to { transform: rotate(360deg); } }



.student-portal-container.mobile-mode .mobile-bottom-bar .wallet-link-button {
  flex: 1 1 auto;
  padding: 10px 12px;
  border-radius: 14px;
  font-weight: 800;
  background: linear-gradient(90deg, rgba(124,58,237,0.95), rgba(34,211,238,0.9));
  border: 1px solid rgba(255,255,255,0.06);
  box-shadow: 0 10px 30px rgba(124,58,237,0.12);
}

/* Compact award card variant */
.award-card.small {
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.student-portal-container.mobile-mode .award-card.small {
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border: 1px solid rgba(255,255,255,0.04);
}

/* Compact flowchart card */
.student-portal-container.mobile-mode .flowchart-compact-card {
  min-width: 120px;
  padding: 8px;
  border-radius: 10px;
  background: rgba(15,23,42,0.6);
  border: 1px solid var(--portal-border);
}

/* Make wallet-link-button in desktop/profile view visually consistent */
.wallet-link-button {
  display: inline-block;
  background: linear-gradient(135deg, #7c3aed 0%, #22d3ee 100%);
  color: #fff;
  border: none;
  padding: 8px 12px;
}

/* Badge image sizing: ensure IPFS images render cleanly on mobile/desktop */
.badge-img {
  width: 56px;
  height: 56px;
  object-fit: contain;
  display: block;
  margin: 0 auto 8px auto;
}

.badge-card .badge-placeholder { font-size: 48px; }

.wallet-link-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 22px rgba(124, 58, 237, 0.18);
}

/* Mobile Attendance Calendar - Responsive */
.student-portal-container.mobile-mode .attendance-calendar {
  gap: 6px;
}

.student-portal-container.mobile-mode .calendar-day {
  width: 36px;
  height: 36px;
  font-size: 11px;
}

/* Mobile Info Cards - Full width */
.student-portal-container.mobile-mode .info-card {
  padding: 16px;
}

.student-portal-container.mobile-mode .info-card h3 {
  font-size: 16px;
}

/* Responsive - Tablet & Mobile */
@media (max-width: 768px) {
  .student-portal-container {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }

  .portal-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .portal-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .portal-tabs::-webkit-scrollbar {
    display: none;
  }

  .portal-tab {
    font-size: 13px;
    padding: 12px 18px;
  }

  .portal-content {
    padding: 16px;
  }

  .profile-grid {
    grid-template-columns: 1fr;
  }

  .awards-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .message-item {
    max-width: 85% !important;
  }

  .student-info h2 {
    font-size: 20px;
  }

  .student-avatar {
    width: 70px;
    height: 70px;
    font-size: 30px;
  }

  .portal-header {
    padding: 16px 20px;
  }

  .portal-header h2 {
    font-size: 22px;
  }

  .admin-student-selector {
    flex-direction: column;
    gap: 12px;
  }

  .stat-value {
    font-size: 24px;
  }

  .stat-label {
    font-size: 11px;
  }
}

/* Extra Small Devices - Phone Portrait */
@media (max-width: 480px) {
  .portal-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 12px;
  }

  .stat-card {
    padding: 14px 10px;
  }

  .stat-icon {
    font-size: 24px;
  }

  .stat-value {
    font-size: 22px;
  }

  .stat-label {
    font-size: 10px;
  }

  .portal-tab {
    font-size: 12px;
    padding: 10px 14px;
  }

  .portal-content {
    padding: 12px;
  }

  .student-info h2 {
    font-size: 18px;
  }

  .student-avatar {
    width: 60px;
    height: 60px;
    font-size: 26px;
  }

  .message-input {
    font-size: 14px;
  }

  .send-button {
    width: 44px;
    height: 44px;
  }

  .awards-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .belt-step {
    min-width: 45px;
    font-size: 11px;
  }

  .portal-close-btn {
    width: 40px;
    height: 40px;
    font-size: 26px;
    top: 10px;
    right: 10px;
  }
}

/* Landscape Mobile - Optimize horizontal space */
@media (max-width: 768px) and (orientation: landscape) {
  .student-portal-container {
    height: 100vh;
  }

  .portal-stats {
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  .stat-card {
    padding: 12px 8px;
  }

  .stat-icon {
    font-size: 22px;
    margin-bottom: 4px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-label {
    font-size: 10px;
  }

  .portal-content {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
}

/* Touch-specific enhancements */
@media (hover: none) and (pointer: coarse) {
  /* Larger touch targets */
  .portal-tab {
    min-height: 44px;
  }

  button {
    min-height: 44px;
    min-width: 44px;
  }

  /* Better tap highlighting */
  .portal-tab,
  .stat-card,
  .message-item,
  button {
    -webkit-tap-highlight-color: rgba(124, 58, 237, 0.3);
  }

  /* Disable hover effects on touch */
  .stat-card:hover,
  .portal-tab:hover,
  button:hover {
    transform: none;
  }

  /* Active state feedback */
  .portal-tab:active {
    transform: scale(0.97);
  }

  .stat-card:active {
    transform: scale(0.98);
  }

  button:active {
    transform: scale(0.95);
  }
}

/* ============================================================================
   PROFILE EDITING & PAYMENT FEATURES
   ============================================================================ */

/* Profile Header Actions */
.profile-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.btn-edit-profile {
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-edit-profile:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.4);
}

/* Payment Plans */
.payment-plans {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 16px;
  padding: 30px;
  margin: 24px 0;
  backdrop-filter: blur(8px);
}

.payment-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 20px;
  flex-wrap: wrap;
}

.payment-plans h4 {
  margin: 0 0 8px;
  color: var(--portal-text);
  font-size: 22px;
}

.payment-subtitle {
  color: var(--portal-muted);
  margin: 0 0 24px;
  font-size: 14px;
}

/* Currency Toggle */
.currency-toggle {
  display: flex;
  gap: 8px;
  background: rgba(0, 0, 0, 0.3);
  padding: 4px;
  border-radius: 12px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.2);
}

.currency-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.currency-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
}

.currency-btn.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* ETH Price Display */
.eth-price-display {
  background: linear-gradient(135deg, rgba(34, 211, 238, 0.1) 0%, rgba(124, 58, 237, 0.1) 100%);
  border: 1px solid rgba(34, 211, 238, 0.3);
  border-radius: 12px;
  padding: 12px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 600;
  color: var(--portal-text);
}

.eth-icon {
  font-size: 20px;
  color: #22d3ee;
}

.live-indicator {
  margin-left: auto;
  font-size: 12px;
  color: #4ade80;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.eth-price-loading {
  background: rgba(34, 211, 238, 0.05);
  border: 1px dashed rgba(34, 211, 238, 0.3);
  border-radius: 12px;
  padding: 12px 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 14px;
  color: var(--portal-muted);
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.plan-card {
  background: rgba(30, 41, 59, 0.7);
  border: 2px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.plan-card:hover {
  border-color: var(--portal-primary);
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(124, 58, 237, 0.3);
}

.plan-card.selected {
  border-color: var(--portal-accent);
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.22) 0%, rgba(34, 211, 238, 0.22) 100%);
  box-shadow: 0 18px 40px rgba(34, 211, 238, 0.22), 0 6px 20px rgba(124,58,237,0.10);
  transform: translateY(-6px) scale(1.02);
  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;
  border-width: 2.5px;
}

.plan-selected-tag {
  margin-top: 12px;
  display: inline-block;
  padding: 6px 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(34,211,238,0.18), rgba(124,58,237,0.22));
  color: var(--portal-text);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.2px;
  /* visually attach badge to the card */
  position: absolute;
  top: 12px;
  right: 12px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.28);
}

.plan-card {
  position: relative; /* ensure the selected badge can be absolutely positioned */
}

/* Strong focus ring for keyboard users */
.plan-card:focus {
  outline: none;
  box-shadow: 0 0 0 4px rgba(124,58,237,0.18), 0 8px 20px rgba(0,0,0,0.25);
  transform: translateY(-4px) scale(1.01);
}

/* mobile plan card selected visual parity */
.mobile-plan-card.selected {
  border-color: var(--portal-accent);
  background: linear-gradient(180deg, rgba(124,58,237,0.06), rgba(34,211,238,0.04));
  box-shadow: 0 12px 28px rgba(124,58,237,0.12);
  transform: translateY(-4px);
}

.plan-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.plan-icon {
  font-size: 32px;
}

.plan-name {
  font-size: 20px;
  font-weight: 700;
  color: var(--portal-text);
}

.plan-price {
  font-size: 48px;
  font-weight: 900;
  background: linear-gradient(135deg, #22d3ee 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 12px 0;
}

.plan-desc {
  color: var(--portal-muted);
  font-size: 14px;
  margin-bottom: 20px;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.plan-features li {
  color: var(--portal-text);
  padding: 8px 0;
  font-size: 14px;
}

.btn-pay-metamask {
  width: 100%;
  background: linear-gradient(135deg, #f6851b 0%, #e2761b 100%);
  color: #fff;
  border: none;
  padding: 16px 32px;
  border-radius: 30px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}

.btn-pay-metamask:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(246, 133, 27, 0.5);
}

.btn-pay-metamask:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.metamask-icon {
  font-size: 24px;
}

.metamask-warning {
  text-align: center;
  color: var(--portal-warning);
  font-size: 14px;
  margin-top: 16px;
}

.metamask-warning a {
  color: var(--portal-accent);
  text-decoration: underline;
}

/* Payment History */
.payment-history {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--portal-border);
  border-radius: 16px;
  padding: 24px;
  margin: 24px 0;
}

.payment-history h4 {
  margin: 0 0 20px;
  color: var(--portal-text);
  font-size: 18px;
}

.payment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.payment-item {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(30, 41, 59, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s ease;
}

.payment-item:hover {
  border-color: var(--portal-primary);
  transform: translateX(4px);
}

.payment-item-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 211, 238, 0.2);
  border-radius: 50%;
}

.payment-item-details {
  flex: 1 1;
}

.payment-item-amount {
  font-size: 20px;
  font-weight: 700;
  color: var(--portal-success);
}

.payment-eth-amount {
  font-size: 14px;
  font-weight: 500;
  color: #22d3ee;
  margin-left: 8px;
}

.payment-item-plan {
  color: var(--portal-muted);
  font-size: 13px;
  text-transform: capitalize;
}

.payment-item-date {
  color: var(--portal-muted);
  font-size: 12px;
}

.payment-item-link {
  color: var(--portal-accent);
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  background: rgba(34, 211, 238, 0.1);
  border-radius: 6px;
  transition: all 0.2s ease;
}

.payment-item-link:hover {
  background: rgba(34, 211, 238, 0.2);
}

.payment-reminder-info {
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid var(--portal-primary);
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
}

.payment-reminder-info h4 {
  margin: 0 0 12px;
  color: var(--portal-text);
  font-size: 16px;
}

.payment-reminder-info p {
  margin: 8px 0;
  color: var(--portal-muted);
  font-size: 14px;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(20px);
  z-index: 60000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%);
  border: 2px solid rgba(124, 58, 237, 0.4);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(124, 58, 237, 0.3);
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}

.modal-header h3 {
  margin: 0;
  font-size: 24px;
  background: linear-gradient(135deg, #a855f7, #22d3ee);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.modal-close {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.modal-close:hover {
  background: rgba(239, 68, 68, 0.4);
  transform: rotate(90deg);
}

.modal-body {
  padding: 30px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 30px;
  border-top: 1px solid rgba(148, 163, 184, 0.2);
}

/* Edit Profile Modal */
.edit-profile-modal .form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.form-field label {
  color: var(--portal-accent);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-field input,
.form-field textarea {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  padding: 12px 16px;
  color: var(--portal-text);
  font-size: 15px;
  transition: all 0.2s ease;
}

.form-field input:focus,
.form-field textarea:focus {
  outline: none;
  border-color: var(--portal-primary);
  box-shadow: 0 0 20px rgba(124, 58, 237, 0.3);
  transform: translateY(-2px);
}

.btn-cancel,
.btn-save,
.btn-pay {
  padding: 12px 28px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-cancel {
  background: rgba(100, 116, 139, 0.2);
  border: 1px solid rgba(148, 163, 184, 0.3);
  color: var(--portal-text);
}

.btn-cancel:hover {
  background: rgba(100, 116, 139, 0.3);
}

.btn-save,
.btn-pay {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: #fff;
}

.btn-save:hover:not(:disabled),
.btn-pay:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(34, 197, 94, 0.4);
}

.btn-save:disabled,
.btn-pay:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Payment Modal */
.payment-modal {
  max-width: 500px;
}

.payment-confirmation {
  text-align: center;
}

.payment-plan-summary {
  margin-bottom: 30px;
}

.plan-icon-large {
  font-size: 64px;
  margin-bottom: 16px;
}

.payment-plan-summary h4 {
  margin: 0 0 12px;
  color: var(--portal-text);
  font-size: 22px;
}

.payment-amount-large {
  font-size: 56px;
  font-weight: 900;
  background: linear-gradient(135deg, #22d3ee 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 16px 0;
}

.payment-desc {
  color: var(--portal-muted);
  font-size: 16px;
}

.payment-details-box {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  padding: 20px;
  margin: 24px 0;
  text-align: left;
}

.payment-detail-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  color: var(--portal-text);
  font-size: 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
}

.payment-detail-row:last-child {
  border-bottom: none;
}

.payment-detail-row.total {
  font-size: 18px;
  font-weight: 700;
  color: var(--portal-success);
  padding-top: 16px;
  margin-top: 8px;
  border-top: 2px solid rgba(34, 211, 238, 0.3);
}

.payment-info {
  margin: 24px 0;
  text-align: left;
}

.payment-info p {
  margin: 8px 0;
  color: var(--portal-muted);
  font-size: 14px;
}

.mono {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 13px;
}

/* Mobile responsiveness for modals */
@media (max-width: 768px) {
  .modal-content {
    max-width: 95%;
  }

  .edit-profile-modal .form-grid {
    grid-template-columns: 1fr;
  }

  .plans-grid {
    grid-template-columns: 1fr;
  }

  .payment-amount-large {
    font-size: 48px;
  }
}

@media (max-width: 480px) {
  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 20px;
  }

  .btn-pay-metamask {
    font-size: 16px;
    padding: 14px 24px;
  }

  .payment-amount-large {
    font-size: 42px;
  }
}

/* Technique badge shown above progress bars */
.tech-badge {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255,215,0,0.12), rgba(255,255,255,0.02));
  border: 1px solid rgba(255,215,0,0.18);
  font-size: 12px;
  line-height: 1;
  color: #ffd700;
  box-shadow: 0 4px 10px rgba(0,0,0,0.35);
}

/* Floating wallet connect indicator */
.wallet-floating {
  position: fixed;
  top: 18px;
  right: 18px;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 60001;
  cursor: pointer;
  border: 2px solid rgba(255,255,255,0.06);
  background: rgba(6,8,15,0.6);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.wallet-floating:hover { transform: translateY(-3px); }

.wallet-floating.connected { background: linear-gradient(135deg,#16a34a,#22c55e); box-shadow: 0 6px 20px rgba(34,197,94,0.18); color: white; }
.wallet-floating.disconnected { background: linear-gradient(135deg,#ef4444,#f97316); box-shadow: 0 6px 20px rgba(239,68,68,0.14); color: white; }

.wallet-floating .wf-icon { font-size: 18px; display: inline-block; }

/* Make sure on small screens the floating icon isn't intrusive */
@media (max-width: 480px) {
  .wallet-floating { top: 12px; right: 12px; width: 40px; height: 40px; }
}

/* Mobile: place wallet indicator inside the portal container corner, smaller and touch-friendly */
.student-portal-container.mobile-mode .wallet-floating {
  position: absolute; /* positioned relative to container */
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  padding: 2px;
  background: rgba(0,0,0,0.35);
  border: 1px solid rgba(255,255,255,0.04);
  box-shadow: 0 6px 18px rgba(0,0,0,0.45);
  z-index: 1200;
}

.student-portal-container.mobile-mode .wallet-floating.connected { background: linear-gradient(135deg,#10b981,#34d399); box-shadow: 0 6px 18px rgba(16,185,129,0.14); }
.student-portal-container.mobile-mode .wallet-floating.disconnected { background: linear-gradient(135deg,#ef4444,#fb923c); box-shadow: 0 6px 18px rgba(239,68,68,0.12); }

.student-portal-container.mobile-mode .wallet-floating .wf-icon { font-size: 14px; line-height: 1; }
.student-portal-container.mobile-mode .wallet-floating:active { transform: translateY(0); }
.student-portal-container.mobile-mode .wallet-floating { touch-action: manipulation; }

/* Trophy area styles */
.progress-bar {
  height: 10px;
  border-radius: 6px;
  background: rgba(255,255,255,0.06);
  margin-top: 6px;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, var(--portal-primary), var(--portal-accent));
}

.attendance-progress .progress-bar-fill {
  background: linear-gradient(90deg, var(--portal-warning), #ef4444);
}

.belt-attained-badge {
  background: linear-gradient(90deg, var(--portal-warning), #ef4444);
  /* use portal text for better contrast on dark/light themes */
  color: var(--portal-text);
  padding: 6px 10px;
  border-radius: 999px;
  font-weight: 800;
}

/* Mobile-specific contrast overrides to avoid black text on bright gradients
   Improves navigation legibility and small badges on mobile screens. */
.student-portal-container.mobile-mode .payment-badge.payment-due,
.student-portal-container.mobile-mode .belt-attained-badge,
.student-portal-container.mobile-mode .trophy-chip .trophy-name,
.student-portal-container.mobile-mode .trophy-chip .trophy-count,
.student-portal-container.mobile-mode .mobile-bottom-bar,
.student-portal-container.mobile-mode .mobile-bottom-bar * {
  color: var(--portal-text) !important;
  text-shadow: 0 1px 2px rgba(216, 214, 214, 0.6);
}

.student-portal-container.mobile-mode .mobile-header-actions,
.student-portal-container.mobile-mode .mobile-header-actions * {
  color: #fff !important;
  text-shadow: 0 1px 2px rgba(197, 195, 195, 0.6);
}

/* Strong mobile-mode color reset: ensure no dark/black lettering appears
   inside the student portal on small devices. This forces readable text
   across gradients and light backgrounds used in mobile variants. */
.student-portal-container.mobile-mode,
.student-portal-container.mobile-mode * {
  color: var(--portal-text) !important;
}

/* Keep interactive controls using their own explicit color rules */
.student-portal-container.mobile-mode a,
.student-portal-container.mobile-mode button,
.student-portal-container.mobile-mode .btn-sm,
.student-portal-container.mobile-mode .wallet-link-button {
  color: inherit !important;
}

.trophy-header { display: flex; align-items: center; gap: 12px; }
.trophy-header .trophy-title { font-weight: 800; font-size: 16px; color: var(--portal-text); }
.trophy-header .trophy-sub { color: var(--portal-muted); font-size: 13px; }

.mobile-pay-confirm .wallet-row .wallet-badge,
.trophy-chip .trophy-name,
.trophy-chip .trophy-count { color: var(--portal-text); }
.trophy-area {
  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
  border: 1px solid rgba(148,163,184,0.06);
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(141, 141, 142, 0.35);
}

.trophy-list { display: flex; gap: 10px; align-items: center; }

.trophy-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(15,23,42,0.6);
  border: 1px solid rgba(255,255,255,0.02);
}

.trophy-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: linear-gradient(135deg, rgba(255,215,0,0.15), rgba(255,255,255,0.02));
  color: #ffd700;
  border: 1px solid rgba(255,215,0,0.12);
  box-shadow: 0 6px 18px rgba(255,215,0,0.06);
}

.trophy-meta { display: flex; flex-direction: column; }
.trophy-name { font-weight: 700; font-size: 13px; color: var(--portal-text); text-transform: capitalize; }
.trophy-count { font-size: 12px; color: var(--portal-muted); }

`, "",{"version":3,"sources":["webpack://./src/components/StudentPortal.css"],"names":[],"mappings":"AAAA;;;iFAGiF;;AAEjF;EACE,yBAAyB;EACzB,wBAAwB;EACxB,wCAAwC;EACxC,yCAAyC;EACzC,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb;;;kEAGgE;EAChE,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;oFAGkF;EAClF,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;yEAEuE;EACvE,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,qFAAqF;EACrF,0CAA0C;EAC1C,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;EACxC;;;mCAGiC;EACjC;;;yBAGuB;AACzB;;AAEA;EACE,uGAAuG;EACvG,0DAA0D;AAC5D;;AAEA;EACE,qFAAqF;EACrF,wCAAwC;EACxC,+CAA+C;EAC/C,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,WAAW,qBAAqB,EAAE;EAClC,MAAM,uBAAuB,EAAE;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;EACxC;;;mCAGiC;EACjC;;;yBAGuB;AACzB;;AAEA;EACE,4FAA4F;EAC5F,+CAA+C;AACjD;;AAEA;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW,qBAAqB,EAAE;EAClC,MAAM,uBAAuB,EAAE;AACjC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kCAAkC;EAClC,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC;AAClC,6BAA6B;AAC7B,kCAAkC;AAClC;EACE,yBAAyB;EACzB;;;yCAGuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB;;;0CAGwC;EACxC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,wBAAwB;AACxB,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;2CAGyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,6CAA6C;AAC7C,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;0CAGwC;EACxC;;;;GAIC;EACD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,gCAAgC;AAChC,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;2CAGyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,8BAA8B;AAC9B,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;2CAGyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,+BAA+B;AAC/B,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;2CAGyC;EACzC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC,8BAA8B;AAC9B,kCAAkC;;AAElC;EACE,yBAAyB;EACzB;;;4CAG0C;EAC1C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sFAAsF;EACtF,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,WAAW,6CAA6C,EAAE;EAC1D,MAAM,8EAA8E,EAAE;AACxF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,uFAAuF;EACvF,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;kEACkE;AAClE;EACE;IACE,kBAAkB;IAClB,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;EACrB;EACA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,0BAA0B;EAC5B;EACA,kBAAkB,2BAA2B,EAAE,uCAAuC,EAAE;EACxF,mBAAmB,kDAAkD,EAAE,WAAW,EAAE,yBAAyB,EAAE;EAC/G,qBAAqB,iBAAiB,EAAE,uBAAuB,EAAE,sCAAsC,EAAE;;EAEzG,6EAA6E;EAC7E;IACE,sBAAsB;IACtB,kBAAkB;IAClB,6CAA6C;EAC/C;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,uFAAuF;EACvF,yBAAyB;EACzB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uFAAuF;EACvF,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wFAAwF;EACxF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uFAAuF;EACvF,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,uFAAuF;EACvF,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE,8EAA8E;AAChF;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;EAEE,kDAAkD;EAClD,WAAW;EACX,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC,gBAAgB,2BAA2B,EAAE;AAC7C,iBAAiB,gCAAgC,EAAE,kCAAkC,EAAE;;AAEvF,iDAAiD;AACjD,kBAAkB,2BAA2B,EAAE;AAC/C,mBAAmB,wBAAwB,EAAE;AAC7C,mBAAmB,6CAA6C,EAAE;;AAElE,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,eAAe;EACf,0EAA0E;AAC5E;AACA,sBAAsB,2BAA2B,EAAE,uCAAuC,EAAE;AAC5F,uBAAuB,wBAAwB,EAAE,gBAAgB,EAAE;AACnE,yBAAyB,wCAAwC,EAAE,oDAAoD,EAAE;;AAEzH,sDAAsD;AACtD,sDAAsD,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAErG,+CAA+C;AAC/C,SAAS,0CAA0C,EAAE;;;AAGrD;EACE,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;;AAEA;;;iFAGiF;;AAEjF,gCAAgC;AAChC;EACE,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,mFAAmF;EACnF,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU,EAAE,2EAA2E;EACvF,WAAW;EACX,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,qCAAqC;EACrC,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mFAAmF;EACnF,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yEAAyE;AAC3E;AACA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mFAAmF;EACnF,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,yGAAyG;AACzG;;EAEE,wFAAwF;EACxF,WAAW;EACX,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA,6FAA6F;AAC7F;EACE,8DAA8D;EAC9D,8CAA8C;EAC9C,wDAAwD;AAC1D;AACA;EACE,8DAA8D;EAC9D,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;;EAEE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,oFAAoF;EACpF,wCAAwC;AAC1C;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mFAAmF;EACnF,wCAAwC;AAC1C;;AAEA,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,8EAA8E;EAC9E,4CAA4C;EAC5C,8CAA8C;EAC9C,0CAA0C;EAC1C,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kDAAkD;EAClD,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mDAAmD;EACnD,4CAA4C;AAC9C;AACA,gCAAgC,eAAe,EAAE,gBAAgB,EAAE;AACnE,sBAAsB,gBAAgB,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEjH;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2FAA2F;EAC3F,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA,mCAAmC,uBAAuB,EAAE,YAAY,EAAE,yBAAyB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEvI,sEAAsE;AACtE;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc,EAAE,+CAA+C;AACjE;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,oDAAoD;EACpD,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;;;AAIpD;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,+EAA+E;EAC/E,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mFAAmF;EACnF,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA,iCAAiC,eAAe,EAAE;;AAElD;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,4CAA4C;AAC5C;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,qCAAqC;IACrC,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;EAClB;AACF;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,4BAA4B;EAC5B;;;;IAIE,oDAAoD;EACtD;;EAEA,mCAAmC;EACnC;;;IAGE,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;;iFAEiF;;AAEjF,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,6FAA6F;EAC7F,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,+FAA+F;EAC/F,kFAAkF;EAClF,uCAAuC;EACvC,uGAAuG;EACvG,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gFAAgF;EAChF,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB,EAAE,2DAA2D;AACjF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,wEAAwE;EACxE,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE,kCAAkC;EAClC,iFAAiF;EACjF,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,0EAA0E;EAC1E,yCAAyC;EACzC,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iFAAiF;EACjF,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,cAAc;EACd,uCAAuC;AACzC;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA,yBAAyB,2BAA2B,EAAE;;AAEtD,6BAA6B,mDAAmD,EAAE,2CAA2C,EAAE,YAAY,EAAE;AAC7I,gCAAgC,mDAAmD,EAAE,2CAA2C,EAAE,YAAY,EAAE;;AAEhJ,4BAA4B,eAAe,EAAE,qBAAqB,EAAE;;AAEpE,iEAAiE;AACjE;EACE,mBAAmB,SAAS,EAAE,WAAW,EAAE,WAAW,EAAE,YAAY,EAAE;AACxE;;AAEA,kGAAkG;AAClG;EACE,kBAAkB,EAAE,qCAAqC;EACzD,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;AACf;;AAEA,mEAAmE,mDAAmD,EAAE,4CAA4C,EAAE;AACtK,sEAAsE,mDAAmD,EAAE,2CAA2C,EAAE;;AAExK,kEAAkE,eAAe,EAAE,cAAc,EAAE;AACnG,gEAAgE,wBAAwB,EAAE;AAC1F,yDAAyD,0BAA0B,EAAE;;AAErF,uBAAuB;AACvB;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+EAA+E;AACjF;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kEAAkE;EAClE,6DAA6D;EAC7D,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;uEACuE;AACvE;;;;;;EAME,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;;EAEE,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;;oEAEoE;AACpE;;EAEE,oCAAoC;AACtC;;AAEA,mEAAmE;AACnE;;;;EAIE,yBAAyB;AAC3B;;AAEA,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAChE,+BAA+B,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE;AAC7F,6BAA6B,0BAA0B,EAAE,eAAe,EAAE;;AAE1E;;6BAE6B,yBAAyB,EAAE;AACxD;EACE,mFAAmF;EACnF,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA,eAAe,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iFAAiF;EACjF,cAAc;EACd,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE;AACtD,eAAe,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,0BAA0B,EAAE;AACzG,gBAAgB,eAAe,EAAE,0BAA0B,EAAE","sourcesContent":["/* ============================================================================\n   StudentPortal.css — BragaBJJ Student Dashboard Styles\n   Enhanced with KioskMode-inspired glassmorphic design\n   ============================================================================ */\n\n:root {\n  --portal-primary: #7c3aed;\n  --portal-accent: #22d3ee;\n  --portal-surface: rgba(15, 23, 42, 0.65);\n  --portal-border: rgba(148, 163, 184, 0.2);\n  --portal-text: #e2e8f0;\n  --portal-muted: #94a3b8;\n  --portal-success: #22c55e;\n  --portal-warning: #f59e0b;\n}\n\n.student-portal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background:\n    radial-gradient(120% 120% at 0% 0%, rgba(124, 58, 237, 0.32) 0%, rgba(15, 23, 42, 0.95) 38%),\n    radial-gradient(110% 110% at 100% 0%, rgba(34, 211, 238, 0.28) 0%, rgba(15, 23, 42, 0.92) 42%),\n    linear-gradient(160deg, #050614 0%, #0b1120 45%, #050614 100%);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  z-index: 50000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: portalFadeIn 0.3s ease-out;\n}\n\n.student-portal-overlay::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at 20% 25%, rgba(94, 234, 212, 0.12) 0%, transparent 45%),\n    radial-gradient(circle at 80% 20%, rgba(129, 140, 248, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 50% 90%, rgba(14, 165, 233, 0.14) 0%, transparent 55%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.student-portal-overlay::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(125, 211, 252, 0.08) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(124, 58, 237, 0.08) 1px, transparent 1px);\n  background-size: 80px 80px;\n  pointer-events: none;\n  opacity: 0.35;\n  z-index: 0;\n}\n\n@keyframes portalFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.student-portal-container {\n  width: 95%;\n  max-width: 1200px;\n  height: 90vh;\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 24px;\n  box-shadow: 0 22px 45px rgba(2, 6, 23, 0.35), 0 1px 0 rgba(255, 255, 255, 0.04) inset;\n  backdrop-filter: blur(32px) saturate(170%);\n  -webkit-backdrop-filter: blur(32px) saturate(170%);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: portalSlideUp 0.4s ease-out;\n  position: relative;\n  z-index: 1;\n}\n\n/* Golden profile styling for Samuel Braga */\n.student-portal-container.golden-profile {\n  border: 2px solid rgba(255, 215, 0, 0.6);\n  box-shadow: \n    0 22px 45px rgba(255, 215, 0, 0.25), \n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 60px rgba(255, 215, 0, 0.2);\n  background: \n    radial-gradient(circle at top left, rgba(255, 215, 0, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at bottom right, rgba(255, 165, 0, 0.08) 0%, transparent 50%),\n    var(--portal-surface);\n}\n\n.student-portal-container.golden-profile .portal-header {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 165, 0, 0.1) 100%) !important;\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3) !important;\n}\n\n.student-portal-container.golden-profile .portal-header h2 {\n  background: linear-gradient(135deg, #ffd700 0%, #ffaa00 45%, #ffd700 100%) !important;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  background-clip: text !important;\n  animation: goldenShimmer 3s ease-in-out infinite;\n}\n\n@keyframes goldenShimmer {\n  0%, 100% { filter: brightness(1); }\n  50% { filter: brightness(1.3); }\n}\n\n.student-portal-container.golden-profile .stat-card {\n  border-color: rgba(255, 215, 0, 0.3);\n}\n\n.student-portal-container.golden-profile .stat-card:hover {\n  border-color: rgba(255, 215, 0, 0.6);\n  box-shadow: 0 8px 20px rgba(255, 215, 0, 0.3);\n}\n\n/* Golden profile styling for Samuel Braga */\n.student-portal-container.golden-profile {\n  border: 2px solid rgba(255, 215, 0, 0.6);\n  box-shadow: \n    0 22px 45px rgba(255, 215, 0, 0.25), \n    0 1px 0 rgba(255, 255, 255, 0.04) inset,\n    0 0 60px rgba(255, 215, 0, 0.2);\n  background: \n    radial-gradient(circle at top left, rgba(255, 215, 0, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at bottom right, rgba(255, 165, 0, 0.08) 0%, transparent 50%),\n    var(--portal-surface);\n}\n\n.student-portal-container.golden-profile .portal-header {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(255, 165, 0, 0.1) 100%);\n  border-bottom: 1px solid rgba(255, 215, 0, 0.3);\n}\n\n.student-portal-container.golden-profile .portal-header h2 {\n  background: linear-gradient(135deg, #ffd700 0%, #ffaa00 45%, #ffd700 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: goldenShimmer 3s ease-in-out infinite;\n}\n\n@keyframes goldenShimmer {\n  0%, 100% { filter: brightness(1); }\n  50% { filter: brightness(1.3); }\n}\n\n@keyframes portalSlideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Loading & Error States */\n.portal-loading,\n.portal-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #fff;\n  text-align: center;\n  padding: 40px;\n  gap: 20px;\n}\n\n.error-icon {\n  font-size: 80px;\n  margin-bottom: 10px;\n  animation: errorPulse 2s ease-in-out infinite;\n}\n\n@keyframes errorPulse {\n  0%, 100% { opacity: 0.8; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.1); }\n}\n\n.error-message {\n  font-size: 16px;\n  color: #e9e1ff;\n  margin: 10px 0;\n  max-width: 500px;\n}\n\n.wallet-display {\n  background: rgba(0, 0, 0, 0.4);\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(162, 89, 247, 0.3);\n  margin: 10px 0;\n}\n\n.wallet-display code {\n  color: #00ccff;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 14px;\n  word-break: break-all;\n  background: none;\n  padding: 0;\n}\n\n.error-instructions {\n  background: rgba(162, 89, 247, 0.1);\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid rgba(162, 89, 247, 0.2);\n  max-width: 500px;\n  text-align: left;\n}\n\n.error-instructions p {\n  margin: 0 0 12px;\n  color: #a259f7;\n  font-weight: 600;\n}\n\n.error-instructions ol {\n  margin: 0;\n  padding-left: 20px;\n  color: #e9e1ff;\n}\n\n.error-instructions li {\n  margin: 8px 0;\n  line-height: 1.6;\n}\n\n.btn-primary-portal {\n  background: linear-gradient(135deg, #a259f7 0%, #00ccff 100%);\n  color: #fff;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n}\n\n.btn-primary-portal:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(162, 89, 247, 0.4);\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(162, 89, 247, 0.2);\n  border-top-color: #a259f7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.portal-error h2 {\n  margin: 0 0 10px;\n  color: #e9e1ff;\n  font-size: 32px;\n}\n\n.portal-error code {\n  background: rgba(0, 0, 0, 0.3);\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 13px;\n  color: #00ccff;\n  margin: 10px 0;\n  display: inline-block;\n}\n\n/* Header */\n.portal-header {\n  padding: 24px 30px;\n  background: rgba(15, 23, 42, 0.45);\n  border-bottom: 1px solid var(--portal-border);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  position: relative;\n}\n\n.portal-header h2 {\n  margin: 0;\n  color: var(--portal-text);\n  font-size: 28px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 45%, #f8fafc 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.portal-subtitle {\n  color: var(--portal-muted);\n  font-size: 14px;\n  margin: 4px 0 0;\n}\n\n/* ============================= */\n/* ADMIN BADGE NEON BORDERS */\n/* ============================= */\n.profile-doctor-green {\n  border: 3px solid #00ff88;\n  box-shadow:\n    0 0 12px rgba(0, 255, 136, 0.8),\n    0 0 24px rgba(0, 255, 136, 0.6),\n    inset 0 0 12px rgba(0, 255, 136, 0.4);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n.profile-baddie {\n  border: 3px solid #ff4fd8;\n  box-shadow:\n    0 0 12px rgba(255, 79, 216, 0.8),\n    0 0 24px rgba(255, 79, 216, 0.6),\n    inset 0 0 12px rgba(255, 79, 216, 0.4);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* COACH – GOLDEN GLOW */\n/* ============================= */\n\n.profile-coach {\n  border: 3px solid #facc15;\n  box-shadow:\n    0 0 14px rgba(250, 204, 21, 0.95),\n    0 0 30px rgba(250, 204, 21, 0.7),\n    inset 0 0 16px rgba(250, 204, 21, 0.45);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* SUPER BADDIE – PINK NEON (INNER + OUTER) */\n/* ============================= */\n\n.profile-super-baddie {\n  border: 3px solid #ff4fd8;\n  box-shadow:\n    0 0 14px rgba(255, 79, 216, 0.95),\n    0 0 28px rgba(255, 79, 216, 0.7),\n    inset 0 0 16px rgba(255, 79, 216, 0.6);\n  background: radial-gradient(\n    circle at top,\n    rgba(255, 79, 216, 0.12),\n    rgba(255, 79, 216, 0.02) 60%\n  );\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* MASTER CLASS – SILVER BADGE */\n/* ============================= */\n\n.profile-master-class {\n  border: 3px solid #cfd8dc;\n  box-shadow:\n    0 0 12px rgba(207, 216, 220, 0.9),\n    0 0 24px rgba(207, 216, 220, 0.6),\n    inset 0 0 12px rgba(207, 216, 220, 0.5);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* SUPER STUDENT – BLUE NEON */\n/* ============================= */\n\n.profile-super-student {\n  border: 3px solid #3b82f6;\n  box-shadow:\n    0 0 12px rgba(59, 130, 246, 0.9),\n    0 0 24px rgba(59, 130, 246, 0.6),\n    inset 0 0 12px rgba(59, 130, 246, 0.45);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* UPCOMING BEAST – CYAN NEON */\n/* ============================= */\n\n.profile-upcoming-beast {\n  border: 3px solid #22d3ee;\n  box-shadow:\n    0 0 12px rgba(34, 211, 238, 0.9),\n    0 0 24px rgba(34, 211, 238, 0.6),\n    inset 0 0 12px rgba(34, 211, 238, 0.45);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n/* ============================= */\n/* CORE STUDENT – WHITE NEON */\n/* ============================= */\n\n.profile-core-student {\n  border: 3px solid #ffffff;\n  box-shadow:\n    0 0 12px rgba(255, 255, 255, 0.95),\n    0 0 24px rgba(255, 255, 255, 0.7),\n    inset 0 0 14px rgba(255, 255, 255, 0.45);\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n.admin-badge-supreme {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.9), rgba(34, 211, 238, 0.75));\n  color: #fff;\n  padding: 8px 16px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  box-shadow: 0 4px 20px rgba(124, 58, 237, 0.5);\n  animation: supremePulse 2s ease-in-out infinite;\n}\n\n@keyframes supremePulse {\n  0%, 100% { box-shadow: 0 4px 20px rgba(255, 215, 0, 0.5); }\n  50% { box-shadow: 0 8px 30px rgba(255, 215, 0, 0.8), 0 0 40px rgba(255, 215, 0, 0.3); }\n}\n\n.admin-student-selector {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 24px;\n  background: rgba(30, 41, 59, 0.7);\n  border-bottom: 1px solid var(--portal-border);\n}\n\n.admin-student-selector label {\n  color: var(--portal-accent);\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.student-select-dropdown {\n  flex: 1;\n  padding: 10px 16px;\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  color: var(--portal-text);\n  font-size: 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.student-select-dropdown:hover {\n  border-color: var(--portal-primary);\n  background: rgba(124, 58, 237, 0.1);\n}\n\n.student-select-dropdown:focus {\n  outline: none;\n  border-color: var(--portal-accent);\n  box-shadow: 0 0 20px rgba(34, 211, 238, 0.3);\n}\n\n.student-count-badge {\n  padding: 6px 14px;\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));\n  border-radius: 20px;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.student-avatar {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #a259f7 0%, #00ccff 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  font-weight: 700;\n  color: #fff;\n  box-shadow: 0 4px 20px rgba(162, 89, 247, 0.4);\n  border: 3px solid rgba(255, 255, 255, 0.1);\n}\n\n.student-info h2 {\n  margin: 0 0 8px;\n  color: #e9e1ff;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.student-belt {\n  margin: 4px 0;\n  color: #a259f7;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.student-wallet {\n  margin: 4px 0;\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 13px;\n  color: #00ccff;\n  opacity: 0.9;\n}\n\n.portal-close-btn {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(148, 163, 184, 0.18);\n  border: 1px solid var(--portal-border);\n  color: var(--portal-text);\n  font-size: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n.portal-close-btn:hover {\n  background: rgba(239, 68, 68, 0.3);\n  border-color: rgba(239, 68, 68, 0.5);\n  transform: scale(1.05);\n}\n\n/* Quick Stats */\n.portal-stats {\n  padding: 5px 10px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));\n  gap: 13px;\n  background: rgba(30, 41, 59, 0.5);\n  border-bottom: 1px solid var(--portal-border);\n}\n\n.stat-card {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 20px;\n  text-align: center;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(8px);\n}\n\n.stat-card:hover {\n  background: rgba(124, 58, 237, 0.15);\n  border-color: var(--portal-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.2);\n}\n\n.stat-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n\n.stat-icon.payment-paid {\n  filter: hue-rotate(90deg);\n}\n\n.stat-icon.payment-due {\n  filter: hue-rotate(30deg);\n}\n\n.stat-icon.payment-overdue {\n  filter: hue-rotate(0deg);\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--portal-text);\n  margin-bottom: 6px;\n  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.stat-label {\n  font-size: 13px;\n  color: var(--portal-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Compact desktop override: make quick-stats smaller and denser for desktop screens\n   without affecting mobile mode which has its own styles above. */\n@media (min-width: 1024px) {\n  .student-portal-container .portal-stats {\n    padding: 12px 18px;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 10px;\n  }\n\n  .student-portal-container .stat-card {\n    padding: 10px 12px;\n    border-radius: 10px;\n    min-height: 56px;\n  }\n\n  .student-portal-container .stat-icon {\n    font-size: 22px;\n    margin-bottom: 6px;\n  }\n\n  .student-portal-container .stat-value {\n    font-size: 18px;\n    font-weight: 800;\n    margin-bottom: 4px;\n  }\n\n  .student-portal-container .stat-label {\n    font-size: 11px;\n    letter-spacing: 0.6px;\n  }\n}\n\n/* Desktop stat-tabs (compact navigation for quick-stats) */\n@media (min-width: 1024px) {\n  .stat-tabs-container {\n    padding: 8px 18px 6px;\n  }\n  .stat-tabs {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n  }\n  .stat-tab {\n    background: rgba(255,255,255,0.02);\n    color: var(--portal-text);\n    border: 1px solid rgba(255,255,255,0.04);\n    padding: 6px 10px;\n    border-radius: 8px;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.14s ease;\n  }\n  .stat-tab:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }\n  .stat-tab.active { background: linear-gradient(90deg,#7c3aed,#22d3ee); color: #fff; border-color: transparent; }\n  .stat-tab.show-all { margin-left: auto; background: transparent; border: 1px solid var(--portal-border); }\n\n  /* Emphasize the active stat and de-emphasize others when a tab is selected */\n  .student-portal-container .stat-card.stat-active {\n    transform: scale(1.04);\n    padding: 12px 14px;\n    box-shadow: 0 10px 30px rgba(124,58,237,0.12);\n  }\n  .student-portal-container .stat-card.stat-dim {\n    opacity: 0.45;\n    transform: scale(0.96);\n  }\n}\n\n/* Tabs */\n.portal-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 16px 30px;\n  background: rgba(15, 23, 42, 0.45);\n  border-bottom: 1px solid var(--portal-border);\n  overflow-x: auto;\n}\n\n.portal-tabs .tab {\n  padding: 10px 20px;\n  background: transparent;\n  border: 1px solid var(--portal-border);\n  border-radius: 8px;\n  color: var(--portal-muted);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  position: relative;\n}\n\n.portal-tabs .tab:hover {\n  background: rgba(124, 58, 237, 0.15);\n  border-color: var(--portal-primary);\n  color: var(--portal-text);\n}\n\n.portal-tabs .tab.active {\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);\n}\n\n.portal-tabs .tab .badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: #ff4444;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* Content Area */\n.portal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 30px;\n}\n\n.tab-panel {\n  animation: tabFadeIn 0.3s ease-out;\n}\n\n@keyframes tabFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tab-panel h3 {\n  margin: 0 0 24px;\n  color: var(--portal-text);\n  font-size: 24px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #f8fafc 0%, #c4b5fd 45%, #f8fafc 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Profile Grid */\n.profile-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.profile-field {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 10px;\n  padding: 16px;\n  backdrop-filter: blur(8px);\n}\n\n.profile-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.profile-field label {\n  display: block;\n  font-size: 12px;\n  color: var(--portal-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n}\n\n.field-value {\n  color: var(--portal-text);\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.field-value.mono {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 14px;\n  color: var(--portal-accent);\n  word-break: break-all;\n}\n\n.belt-badge {\n  display: inline-block;\n  padding: 6px 16px;\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));\n  border-radius: 20px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #fff;\n}\n\n/* Attendance */\n.attendance-summary {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  backdrop-filter: blur(8px);\n}\n\n.attendance-summary p {\n  margin: 8px 0;\n  color: var(--portal-text);\n}\n\n.attendance-summary strong {\n  color: var(--portal-primary);\n  font-weight: 700;\n}\n\n.attendance-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.attendance-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: rgba(15, 23, 42, 0.5);\n  border: 1px solid var(--portal-border);\n  border-radius: 10px;\n  padding: 16px;\n  transition: all 0.2s ease;\n}\n\n.attendance-item:hover {\n  background: rgba(124, 58, 237, 0.12);\n  border-color: var(--portal-primary);\n}\n\n.attendance-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--portal-accent) 0%, var(--portal-primary) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: #fff;\n  font-weight: 700;\n}\n\n.attendance-details {\n  flex: 1;\n}\n\n.attendance-date {\n  color: var(--portal-text);\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.attendance-time {\n  color: var(--portal-muted);\n  font-size: 13px;\n}\n\n/* Belt Progression */\n.belt-journey {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 30px;\n}\n\n.belt-stage {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.5);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  position: relative;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(8px);\n}\n\n.belt-stage.completed {\n  background: rgba(34, 197, 94, 0.1);\n  border-color: rgba(34, 197, 94, 0.3);\n}\n\n.belt-stage.current {\n  background: rgba(124, 58, 237, 0.15);\n  border-color: var(--portal-primary);\n  box-shadow: 0 4px 20px rgba(124, 58, 237, 0.2);\n}\n\n.belt-stage.future {\n  opacity: 0.4;\n}\n\n.belt-name {\n  flex: 1;\n  color: var(--portal-text);\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.belt-current-badge {\n  padding: 6px 12px;\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n}\n\n.belt-info {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 20px;\n  backdrop-filter: blur(8px);\n}\n\n.belt-info h4 {\n  margin: 0 0 12px;\n  color: var(--portal-text);\n  font-size: 18px;\n}\n\n.belt-info p {\n  margin: 8px 0;\n  color: var(--portal-text);\n}\n\n.belt-info strong {\n  color: var(--portal-primary);\n}\n\n/* Awards */\n.awards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.award-card {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 24px;\n  text-align: center;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(8px);\n}\n\n.award-card:hover {\n  background: rgba(124, 58, 237, 0.15);\n  border-color: var(--portal-primary);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(124, 58, 237, 0.3);\n}\n\n.award-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.award-title {\n  color: var(--portal-text);\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.award-desc {\n  color: var(--portal-muted);\n  font-size: 13px;\n}\n\n/* Payments */\n.payment-status-card {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 30px;\n  text-align: center;\n  margin-bottom: 24px;\n  backdrop-filter: blur(8px);\n}\n\n.payment-details p {\n  margin: 8px 0;\n  color: var(--portal-text);\n}\n\n.payment-details strong {\n  color: var(--portal-primary);\n}\n\n.payment-reminder {\n  background: rgba(124, 58, 237, 0.1);\n  border: 1px solid var(--portal-primary);\n  border-radius: 12px;\n  padding: 20px;\n  backdrop-filter: blur(8px);\n}\n\n.payment-reminder h4 {\n  margin: 0 0 12px;\n  color: var(--portal-text);\n}\n\n.payment-reminder p {\n  margin: 8px 0;\n  color: var(--portal-text);\n}\n\n/* Payments */\n.payment-status-card {\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 30px;\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.payment-badge {\n  display: inline-block;\n  padding: 12px 24px;\n  border-radius: 30px;\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.payment-badge.payment-paid {\n  background: linear-gradient(135deg, #00c853 0%, #00e676 100%);\n  color: #fff;\n}\n\n.payment-badge.payment-due {\n  background: linear-gradient(135deg, #ff9800 0%, #ffc107 100%);\n  /* ensure readable text on the orange gradient */\n  color: var(--portal-text);\n}\n\n.payment-badge.payment-overdue {\n  background: linear-gradient(135deg, #d32f2f 0%, #f44336 100%);\n  color: #fff;\n}\n\n.payment-details p {\n  margin: 8px 0;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.payment-details strong {\n  color: #a259f7;\n}\n\n.payment-reminder {\n  background: rgba(162, 89, 247, 0.1);\n  border: 1px solid rgba(162, 89, 247, 0.3);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.payment-reminder h4 {\n  margin: 0 0 12px;\n  color: #e9e1ff;\n}\n\n.payment-reminder p {\n  margin: 8px 0;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* Messages */\n.messages-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: calc(90vh - 400px);\n  min-height: 400px;\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n  background: rgba(15, 23, 42, 0.5);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  backdrop-filter: blur(8px);\n}\n\n.message-item {\n  padding: 16px;\n  border-radius: 12px;\n  animation: messageFadeIn 0.3s ease-out;\n}\n\n@keyframes messageFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message-item.from-admin {\n  background: rgba(124, 58, 237, 0.2);\n  border: 1px solid var(--portal-primary);\n  align-self: flex-start;\n  max-width: 80%;\n}\n\n.message-item.from-student {\n  background: rgba(34, 211, 238, 0.2);\n  border: 1px solid var(--portal-accent);\n  align-self: flex-end;\n  max-width: 80%;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.message-header strong {\n  color: var(--portal-text);\n  font-size: 14px;\n}\n\n.message-time {\n  font-size: 11px;\n  color: var(--portal-muted);\n}\n\n.message-body {\n  color: var(--portal-text);\n  font-size: 14px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.message-compose {\n  display: flex;\n  gap: 12px;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n}\n\n.message-compose textarea {\n  flex: 1;\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid var(--portal-border);\n  border-radius: 8px;\n  padding: 12px;\n  color: var(--portal-text);\n  font-family: inherit;\n  font-size: 14px;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.message-compose textarea:focus {\n  outline: none;\n  border-color: var(--portal-primary);\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n}\n\n.message-compose .btn-primary {\n  padding: 12px 24px;\n  background: linear-gradient(120deg, rgba(124, 58, 237, 0.85), rgba(34, 211, 238, 0.75));\n  border: none;\n  border-radius: 8px;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.message-compose .btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.4);\n}\n\n.message-compose .btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Flowchart Styles */\n.flowchart-view-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.view-tab {\n  padding: 10px 20px;\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.view-tab:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--portal-accent);\n}\n\n.view-tab.active {\n  background: var(--portal-accent);\n  border-color: var(--portal-accent);\n  box-shadow: 0 0 12px rgba(124, 58, 237, 0.4);\n}\n\n.edit-controls {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n}\n\n.btn-edit {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n.btn-edit:hover {\n  background: rgba(59, 130, 246, 0.4);\n  border-color: rgba(59, 130, 246, 0.8);\n}\n\n.btn-success {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: rgba(34, 197, 94, 0.5);\n}\n\n.btn-success:hover {\n  background: rgba(34, 197, 94, 0.4);\n  border-color: rgba(34, 197, 94, 0.8);\n}\n\n.btn-cancel {\n  background: rgba(156, 163, 175, 0.2);\n  border-color: rgba(156, 163, 175, 0.5);\n}\n\n.btn-cancel:hover {\n  background: rgba(156, 163, 175, 0.4);\n  border-color: rgba(156, 163, 175, 0.8);\n}\n\n.flowchart-info {\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 20px;\n  color: var(--portal-muted);\n  font-size: 14px;\n}\n\n.flowchart-toolbar {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.flowchart-toolbar .btn-sm {\n  padding: 8px 16px;\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 8px;\n  color: white;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.flowchart-toolbar .btn-sm:hover {\n  background: var(--portal-accent);\n  border-color: var(--portal-accent);\n  transform: translateY(-2px);\n}\n\n/* General small button hover/active/selected states */\n.btn-sm {\n  transition: transform 0.14s ease, box-shadow 0.14s ease, background 0.14s ease;\n}\n.btn-sm:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(124,58,237,0.08);\n}\n.btn-sm:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n.btn-sm.active,\n.btn-sm.selected {\n  background: linear-gradient(90deg,#7c3aed,#22d3ee);\n  color: #fff;\n  border-color: rgba(124,58,237,0.28);\n  box-shadow: 0 8px 26px rgba(124,58,237,0.16);\n}\n\n/* Small extra-button styles (xs) */\n.btn-xs:hover { transform: translateY(-1px); }\n.btn-xs.active { background: var(--portal-accent); border-color: var(--portal-accent); }\n\n/* View tabs - make hover/tap clearer on mobile */\n.view-tab:hover { transform: translateY(-2px); }\n.view-tab:active { transform: translateY(0); }\n.view-tab.active { box-shadow: 0 12px 36px rgba(124,58,237,0.12); }\n\n/* Color swatch buttons */\n.color-swatch {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid rgba(255,255,255,0.12);\n  padding: 0;\n  cursor: pointer;\n  transition: transform 0.12s ease, box-shadow 0.12s ease, border 0.12s ease;\n}\n.color-swatch:hover { transform: translateY(-2px); box-shadow: 0 8px 18px rgba(0,0,0,0.25); }\n.color-swatch:active { transform: translateY(0); box-shadow: none; }\n.color-swatch.selected { border: 2px solid rgba(255,255,255,0.95); box-shadow: 0 10px 28px rgba(255,255,255,0.06) inset; }\n\n/* Make swatches larger and touch-friendly on mobile */\n.student-portal-container.mobile-mode .color-swatch { width: 36px; height: 36px; border-radius: 8px; }\n\n/* Improve tap highlight and touch experience */\nbutton { -webkit-tap-highlight-color: rgba(0,0,0,0); }\n\n\n.flowchart-toolbar .btn-danger {\n  background: rgba(239, 68, 68, 0.2);\n  border-color: rgba(239, 68, 68, 0.5);\n  margin-left: auto;\n}\n\n.flowchart-toolbar .btn-danger:hover {\n  background: rgba(239, 68, 68, 0.4);\n  border-color: rgba(239, 68, 68, 0.8);\n}\n\n.flowchart-canvas {\n  width: 100%;\n  height: 500px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  margin-bottom: 20px;\n  user-select: none;\n}\n\n.flowchart-node {\n  cursor: grab;\n  transition: all 0.2s;\n}\n\n.flowchart-node:active {\n  cursor: grabbing;\n}\n\n.flowchart-node.selected rect {\n  filter: drop-shadow(0 0 8px rgba(251, 191, 36, 0.6));\n}\n\n.flowchart-node rect {\n  transition: all 0.2s;\n}\n\n.flowchart-node:hover rect {\n  filter: brightness(1.2);\n}\n\n.flowchart-editor {\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.flowchart-editor h4 {\n  margin: 0 0 16px 0;\n  color: white;\n  font-size: 16px;\n}\n\n.editor-field {\n  margin-bottom: 16px;\n}\n\n.editor-field label {\n  display: block;\n  color: var(--portal-muted);\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.editor-field input {\n  width: 100%;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--portal-border);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n}\n\n.editor-field input:focus {\n  outline: none;\n  border-color: var(--portal-accent);\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.type-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.type-badge.guard {\n  background: rgba(59, 130, 246, 0.3);\n  border: 1px solid rgba(59, 130, 246, 0.5);\n}\n\n.type-badge.pass {\n  background: rgba(168, 85, 247, 0.3);\n  border: 1px solid rgba(168, 85, 247, 0.5);\n}\n\n.type-badge.takedown {\n  background: rgba(34, 197, 94, 0.3);\n  border: 1px solid rgba(34, 197, 94, 0.5);\n}\n\n.type-badge.submission {\n  background: rgba(239, 68, 68, 0.3);\n  border: 1px solid rgba(239, 68, 68, 0.5);\n}\n\n.connect-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.btn-xs {\n  padding: 4px 10px;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid var(--portal-border);\n  border-radius: 6px;\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-xs:hover {\n  background: var(--portal-surface);\n  border-color: var(--portal-accent);\n}\n\n.btn-xs.active {\n  background: var(--portal-accent);\n  border-color: var(--portal-accent);\n}\n\n.flowchart-legend {\n  display: flex;\n  gap: 20px;\n  padding: 16px;\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border);\n  border-radius: 12px;\n  flex-wrap: wrap;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--portal-muted);\n  font-size: 13px;\n}\n\n.legend-color {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  color: var(--portal-muted);\n  font-size: 15px;\n  padding: 40px;\n}\n\n/* ============================================================================\n   MOBILE OPTIMIZATIONS\n   Enhanced responsive design for optimal mobile experience\n   ============================================================================ */\n\n/* Mobile Mode Specific Styles */\n.student-portal-container.mobile-mode {\n  width: 100% !important;\n  height: 100vh !important;\n  max-height: 100vh !important;\n  border-radius: 0 !important;\n  overflow-y: auto;\n}\n\n.student-portal-container.mobile-mode .portal-header {\n  padding: 14px 18px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  /* frosted glass header */\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n  backdrop-filter: blur(22px) saturate(150%);\n}\n\n.student-portal-container.mobile-mode .portal-header h2 {\n  font-size: 22px;\n}\n\n.student-portal-container.mobile-mode .portal-subtitle {\n  font-size: 12px;\n}\n\n.student-portal-container.mobile-mode .portal-close-btn {\n  width: 40px;\n  height: 40px;\n  font-size: 28px;\n  top: 12px;\n  left: 12px; /* move close to left on mobile to avoid overlapping the wallet indicator */\n  right: auto;\n  z-index: 1300;\n}\n\n/* Mobile Stats - Compact 3-column grid for smaller size */\n.student-portal-container.mobile-mode .portal-stats {\n  grid-template-columns: repeat(3, 1fr);\n  gap: 6px;\n  padding: 8px 12px;\n}\n\n.student-portal-container.mobile-mode .stat-card {\n  padding: 8px 6px;\n  /* glass surface for stat cards */\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border: 1px solid rgba(255,255,255,0.05);\n  box-shadow: 0 4px 12px rgba(2,6,23,0.25);\n}\n\n.student-portal-container.mobile-mode .stat-icon {\n  font-size: 20px;\n  margin-bottom: 3px;\n  filter: drop-shadow(0 2px 8px rgba(124,58,237,0.1));\n}\n\n.student-portal-container.mobile-mode .stat-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #f8fbff;\n  margin-bottom: 2px;\n}\n\n.student-portal-container.mobile-mode .stat-label {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  line-height: 1.2;\n}\n\n/* Mobile Tabs - Horizontal scroll with better touch */\n.student-portal-container.mobile-mode .portal-tabs {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding: 0 16px;\n  gap: 8px;\n}\n\n.student-portal-container.mobile-mode .portal-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.student-portal-container.mobile-mode .portal-tab {\n  padding: 12px 20px;\n  font-size: 13px;\n  white-space: nowrap;\n  min-width: auto;\n  flex-shrink: 0;\n}\n\n/* Mobile Content Area */\n.student-portal-container.mobile-mode .portal-content {\n  padding: 12px;\n  background: linear-gradient(180deg, rgba(6,8,15,0.02), rgba(6,8,15,0.04));\n}\n.student-portal-container.mobile-mode .profile-grid {\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n.student-portal-container.mobile-mode .student-info h2 {\n  font-size: 20px;\n}\n\n.student-portal-container.mobile-mode .student-avatar {\n  width: 70px;\n  height: 70px;\n  font-size: 32px;\n}\n\n/* Mobile Admin Selector - Stack vertically */\n.student-portal-container.mobile-mode .admin-student-selector {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n  padding: 12px 16px;\n}\n\n.student-portal-container.mobile-mode .student-select-dropdown {\n  width: 100%;\n  font-size: 14px;\n}\n\n.student-portal-container.mobile-mode .student-count-badge {\n  align-self: flex-start;\n  font-size: 12px;\n}\n\n.student-portal-container.mobile-mode .admin-badge-supreme {\n  font-size: 12px;\n  padding: 6px 12px;\n}\n\n/* Mobile Awards Grid - 2 columns */\n.student-portal-container.mobile-mode .awards-grid {\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n\n.student-portal-container.mobile-mode .award-card {\n  padding: 12px;\n}\n\n/* Mobile Messages - Better touch targets */\n.student-portal-container.mobile-mode .message-item {\n  max-width: 85% !important;\n  padding: 12px 14px;\n  font-size: 14px;\n}\n\n.student-portal-container.mobile-mode .message-timestamp {\n  font-size: 11px;\n}\n\n.student-portal-container.mobile-mode .message-input-row {\n  gap: 8px;\n  padding: 12px;\n}\n\n.student-portal-container.mobile-mode .message-input {\n  font-size: 14px;\n  padding: 12px 14px;\n}\n\n.student-portal-container.mobile-mode .send-button {\n  width: 44px;\n  height: 44px;\n  font-size: 18px;\n}\n\n/* Mobile Belt Progression - Responsive */\n.student-portal-container.mobile-mode .belt-progression {\n  gap: 8px;\n}\n\n.student-portal-container.mobile-mode .belt-step {\n  min-width: 50px;\n}\n\n/* Mobile Flowchart - Simplified view */\n.student-portal-container.mobile-mode .flowchart-section {\n  padding: 12px;\n}\n\n.student-portal-container.mobile-mode .flowchart-controls {\n  flex-direction: column;\n  gap: 12px;\n}\n\n.student-portal-container.mobile-mode .flowchart-svg {\n  min-height: 400px;\n}\n\n/* Mobile Payment Status - Compact */\n.student-portal-container.mobile-mode .payment-status-card {\n  padding: 16px;\n}\n\n.student-portal-container.mobile-mode .payment-status-card h3 {\n  font-size: 16px;\n}\n\n/* Mobile Store Items - Single column */\n.student-portal-container.mobile-mode .store-grid {\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n.student-portal-container.mobile-mode .store-item {\n  padding: 16px;\n}\n\n/* Mobile Buttons - Larger touch targets */\n.student-portal-container.mobile-mode button:not(.portal-close-btn):not(.send-button) {\n  min-height: 40px;\n  padding: 10px 14px;\n  font-size: 13px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border: 1px solid rgba(255,255,255,0.04);\n  color: var(--portal-text);\n}\n\n/* Mobile header action buttons (Confirm Wallet / Open Portal / Main Menu) - match portal primary style */\n.student-portal-container.mobile-mode .mobile-header-actions .btn-sm,\n.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button {\n  background: linear-gradient(135deg, rgba(124,58,237,0.95) 0%, rgba(34,211,238,0.9) 100%);\n  color: #fff;\n  border: 1px solid rgba(255,255,255,0.06);\n  padding: 8px 12px;\n  border-radius: 14px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.22s ease;\n  box-shadow: 0 8px 26px rgba(34, 211, 238, 0.12);\n  backdrop-filter: blur(6px);\n}\n\n/* Make the header wallet button explicitly green/red on mobile when connected/disconnected */\n.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button.connected {\n  background: linear-gradient(135deg,#10b981,#34d399) !important;\n  border-color: rgba(16,185,129,0.12) !important;\n  box-shadow: 0 10px 28px rgba(16,185,129,0.12) !important;\n}\n.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button.disconnected {\n  background: linear-gradient(135deg,#ef4444,#fb923c) !important;\n  border-color: rgba(239,68,68,0.12) !important;\n  box-shadow: 0 10px 28px rgba(239,68,68,0.10) !important;\n}\n\n.student-portal-container.mobile-mode .mobile-header-actions .btn-sm:hover,\n.student-portal-container.mobile-mode .mobile-header-actions .wallet-link-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 36px rgba(124, 58, 237, 0.24);\n}\n\n/* Compact small button utility for mobile */\n.student-portal-container.mobile-mode .btn-sm {\n  padding: 8px 10px;\n  font-size: 13px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.015), rgba(255,255,255,0.01));\n  border: 1px solid rgba(255,255,255,0.04);\n}\n\n/* Embedded store container in StudentPortal (desktop) */\n.store-embedded {\n  max-height: 520px;\n  overflow-y: auto;\n  padding: 8px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border: 1px solid rgba(255,255,255,0.04);\n}\n\n/* Modal used by StudentPortal to host StoreOrder on mobile */\n.cc-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2,6,23,0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Raised to sit above portal floating UI and other lower overlays */\n  z-index: 60010;\n}\n.cc-modal {\n  width: 100%;\n  max-width: 980px;\n  max-height: 88vh;\n  overflow: auto;\n  border-radius: 12px;\n  padding: 12px;\n  background: rgba(8,10,18,0.98);\n  box-shadow: 0 18px 60px rgba(2,6,23,0.8);\n}\n\n/* Mobile bottom action bar - sticky, compact */\n.student-portal-container.mobile-mode .mobile-bottom-bar {\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  gap: 8px;\n  padding: 10px 12px;\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(6,8,15,0.04));\n  border-top: 1px solid rgba(255,255,255,0.05);\n  box-shadow: 0 -8px 20px rgba(2,6,23,0.6) inset;\n  backdrop-filter: blur(12px) saturate(130%);\n  z-index: 120;\n}\n\n/* Mobile Payments - components moved from inline styles to CSS classes */\n.mobile-subtab-btn {\n  min-width: 110px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: rgba(255,255,255,0.03);\n  color: #cbd5e1;\n  border: none;\n  cursor: pointer;\n  font-weight: 700;\n}\n.mobile-subtab-btn.active {\n  background: linear-gradient(90deg,#7c3aed,#22d3ee);\n  color: #fff;\n  box-shadow: 0 6px 18px rgba(124,58,237,0.12);\n}\n.mobile-eth-row {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  color: var(--portal-muted);\n}\n.mobile-plan-cards {\n  margin-top: 12px;\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n}\n.mobile-plan-card {\n  min-width: 220px;\n  border-radius: 12px;\n  padding: 12px;\n  background: #071322;\n  color: #e6eef8;\n  transition: all 0.18s ease;\n  box-shadow: none;\n}\n.mobile-plan-card.selected {\n  background: linear-gradient(180deg,#0f172a,#111827);\n  box-shadow: 0 6px 18px rgba(124,58,237,0.18);\n}\n.mobile-plan-card .plan-price { font-size: 18px; font-weight: 900; }\n.mobile-custom-card { min-width: 220px; border-radius: 12px; padding: 12px; background: #071322; color: #e6eef8; }\n\n.mobile-sticky-paybar {\n  position: fixed;\n  left: 12px;\n  right: 12px;\n  bottom: 14px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  z-index: 9999;\n}\n\n.mobile-pay-confirm {\n  max-width: 520px;\n  margin: auto;\n  /* convert to a centered modal by default; use the lightweight overlay below when opening */\n  position: relative;\n  border-radius: 12px;\n  padding: 16px;\n  background: rgba(8,10,18,0.98);\n  box-shadow: 0 18px 60px rgba(2,6,23,0.8);\n}\n.mobile-pay-confirm .modal-close { background: transparent; border: none; color: var(--portal-text); font-size: 20px; cursor: pointer; }\n\n/* Lightweight overlay for centering mobile pay confirmation windows */\n.mobile-pay-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n  z-index: 60020; /* above cc-modal-overlay and wallet-floating */\n}\n\n/* Mobile confirm modal - enhanced layout */\n.mobile-pay-confirm .confirm-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.mobile-pay-confirm .confirm-subtitle {\n  font-size: 13px;\n  color: var(--portal-muted);\n  margin-top: 6px;\n}\n.mobile-pay-confirm .wallet-row {\n  margin-top: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n.mobile-pay-confirm .wallet-row .wallet-badge {\n  background: rgba(255,255,255,0.03);\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-family: monospace;\n  /* ensure high contrast text on varied backgrounds */\n  color: var(--portal-text);\n}\n.mobile-pay-confirm .confirm-amount {\n  margin-top: 12px;\n  text-align: left;\n}\n.mobile-pay-confirm .confirm-amount .amount-value {\n  font-size: 20px;\n  font-weight: 900;\n}\n.mobile-pay-confirm .confirm-amount .amount-sub {\n  font-size: 13px;\n  color: var(--portal-muted);\n  margin-top: 6px;\n}\n.mobile-pay-confirm .confirm-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 14px;\n}\n.mobile-pay-confirm .btn-spinner {\n  position: relative;\n}\n.mobile-pay-confirm .btn-spinner.processing::after {\n  content: '';\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 2px solid rgba(255,255,255,0.2);\n  border-top-color: #fff;\n  display: inline-block;\n  margin-left: 8px;\n  animation: spin 1s linear infinite;\n  vertical-align: middle;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n\n\n.student-portal-container.mobile-mode .mobile-bottom-bar .wallet-link-button {\n  flex: 1 1 auto;\n  padding: 10px 12px;\n  border-radius: 14px;\n  font-weight: 800;\n  background: linear-gradient(90deg, rgba(124,58,237,0.95), rgba(34,211,238,0.9));\n  border: 1px solid rgba(255,255,255,0.06);\n  box-shadow: 0 10px 30px rgba(124,58,237,0.12);\n}\n\n/* Compact award card variant */\n.award-card.small {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.student-portal-container.mobile-mode .award-card.small {\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border: 1px solid rgba(255,255,255,0.04);\n}\n\n/* Compact flowchart card */\n.student-portal-container.mobile-mode .flowchart-compact-card {\n  min-width: 120px;\n  padding: 8px;\n  border-radius: 10px;\n  background: rgba(15,23,42,0.6);\n  border: 1px solid var(--portal-border);\n}\n\n/* Make wallet-link-button in desktop/profile view visually consistent */\n.wallet-link-button {\n  display: inline-block;\n  background: linear-gradient(135deg, #7c3aed 0%, #22d3ee 100%);\n  color: #fff;\n  border: none;\n  padding: 8px 12px;\n}\n\n/* Badge image sizing: ensure IPFS images render cleanly on mobile/desktop */\n.badge-img {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto 8px auto;\n}\n\n.badge-card .badge-placeholder { font-size: 48px; }\n\n.wallet-link-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 22px rgba(124, 58, 237, 0.18);\n}\n\n/* Mobile Attendance Calendar - Responsive */\n.student-portal-container.mobile-mode .attendance-calendar {\n  gap: 6px;\n}\n\n.student-portal-container.mobile-mode .calendar-day {\n  width: 36px;\n  height: 36px;\n  font-size: 11px;\n}\n\n/* Mobile Info Cards - Full width */\n.student-portal-container.mobile-mode .info-card {\n  padding: 16px;\n}\n\n.student-portal-container.mobile-mode .info-card h3 {\n  font-size: 16px;\n}\n\n/* Responsive - Tablet & Mobile */\n@media (max-width: 768px) {\n  .student-portal-container {\n    width: 100%;\n    height: 100vh;\n    border-radius: 0;\n  }\n\n  .portal-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .portal-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n\n  .portal-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .portal-tab {\n    font-size: 13px;\n    padding: 12px 18px;\n  }\n\n  .portal-content {\n    padding: 16px;\n  }\n\n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .awards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .message-item {\n    max-width: 85% !important;\n  }\n\n  .student-info h2 {\n    font-size: 20px;\n  }\n\n  .student-avatar {\n    width: 70px;\n    height: 70px;\n    font-size: 30px;\n  }\n\n  .portal-header {\n    padding: 16px 20px;\n  }\n\n  .portal-header h2 {\n    font-size: 22px;\n  }\n\n  .admin-student-selector {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .stat-value {\n    font-size: 24px;\n  }\n\n  .stat-label {\n    font-size: 11px;\n  }\n}\n\n/* Extra Small Devices - Phone Portrait */\n@media (max-width: 480px) {\n  .portal-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    padding: 12px;\n  }\n\n  .stat-card {\n    padding: 14px 10px;\n  }\n\n  .stat-icon {\n    font-size: 24px;\n  }\n\n  .stat-value {\n    font-size: 22px;\n  }\n\n  .stat-label {\n    font-size: 10px;\n  }\n\n  .portal-tab {\n    font-size: 12px;\n    padding: 10px 14px;\n  }\n\n  .portal-content {\n    padding: 12px;\n  }\n\n  .student-info h2 {\n    font-size: 18px;\n  }\n\n  .student-avatar {\n    width: 60px;\n    height: 60px;\n    font-size: 26px;\n  }\n\n  .message-input {\n    font-size: 14px;\n  }\n\n  .send-button {\n    width: 44px;\n    height: 44px;\n  }\n\n  .awards-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .belt-step {\n    min-width: 45px;\n    font-size: 11px;\n  }\n\n  .portal-close-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 26px;\n    top: 10px;\n    right: 10px;\n  }\n}\n\n/* Landscape Mobile - Optimize horizontal space */\n@media (max-width: 768px) and (orientation: landscape) {\n  .student-portal-container {\n    height: 100vh;\n  }\n\n  .portal-stats {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n  }\n\n  .stat-card {\n    padding: 12px 8px;\n  }\n\n  .stat-icon {\n    font-size: 22px;\n    margin-bottom: 4px;\n  }\n\n  .stat-value {\n    font-size: 20px;\n  }\n\n  .stat-label {\n    font-size: 10px;\n  }\n\n  .portal-content {\n    max-height: calc(100vh - 200px);\n    overflow-y: auto;\n  }\n}\n\n/* Touch-specific enhancements */\n@media (hover: none) and (pointer: coarse) {\n  /* Larger touch targets */\n  .portal-tab {\n    min-height: 44px;\n  }\n\n  button {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  /* Better tap highlighting */\n  .portal-tab,\n  .stat-card,\n  .message-item,\n  button {\n    -webkit-tap-highlight-color: rgba(124, 58, 237, 0.3);\n  }\n\n  /* Disable hover effects on touch */\n  .stat-card:hover,\n  .portal-tab:hover,\n  button:hover {\n    transform: none;\n  }\n\n  /* Active state feedback */\n  .portal-tab:active {\n    transform: scale(0.97);\n  }\n\n  .stat-card:active {\n    transform: scale(0.98);\n  }\n\n  button:active {\n    transform: scale(0.95);\n  }\n}\n\n/* ============================================================================\n   PROFILE EDITING & PAYMENT FEATURES\n   ============================================================================ */\n\n/* Profile Header Actions */\n.profile-header-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.btn-edit-profile {\n  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-edit-profile:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(124, 58, 237, 0.4);\n}\n\n/* Payment Plans */\n.payment-plans {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 16px;\n  padding: 30px;\n  margin: 24px 0;\n  backdrop-filter: blur(8px);\n}\n\n.payment-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.payment-plans h4 {\n  margin: 0 0 8px;\n  color: var(--portal-text);\n  font-size: 22px;\n}\n\n.payment-subtitle {\n  color: var(--portal-muted);\n  margin: 0 0 24px;\n  font-size: 14px;\n}\n\n/* Currency Toggle */\n.currency-toggle {\n  display: flex;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  padding: 4px;\n  border-radius: 12px;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.currency-btn {\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  padding: 8px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n}\n\n.currency-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.currency-btn.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* ETH Price Display */\n.eth-price-display {\n  background: linear-gradient(135deg, rgba(34, 211, 238, 0.1) 0%, rgba(124, 58, 237, 0.1) 100%);\n  border: 1px solid rgba(34, 211, 238, 0.3);\n  border-radius: 12px;\n  padding: 12px 20px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--portal-text);\n}\n\n.eth-icon {\n  font-size: 20px;\n  color: #22d3ee;\n}\n\n.live-indicator {\n  margin-left: auto;\n  font-size: 12px;\n  color: #4ade80;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.eth-price-loading {\n  background: rgba(34, 211, 238, 0.05);\n  border: 1px dashed rgba(34, 211, 238, 0.3);\n  border-radius: 12px;\n  padding: 12px 20px;\n  margin-bottom: 20px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--portal-muted);\n}\n\n.plans-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.plan-card {\n  background: rgba(30, 41, 59, 0.7);\n  border: 2px solid rgba(148, 163, 184, 0.2);\n  border-radius: 16px;\n  padding: 24px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n}\n\n.plan-card:hover {\n  border-color: var(--portal-primary);\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(124, 58, 237, 0.3);\n}\n\n.plan-card.selected {\n  border-color: var(--portal-accent);\n  background: linear-gradient(135deg, rgba(124, 58, 237, 0.22) 0%, rgba(34, 211, 238, 0.22) 100%);\n  box-shadow: 0 18px 40px rgba(34, 211, 238, 0.22), 0 6px 20px rgba(124,58,237,0.10);\n  transform: translateY(-6px) scale(1.02);\n  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background 180ms ease;\n  border-width: 2.5px;\n}\n\n.plan-selected-tag {\n  margin-top: 12px;\n  display: inline-block;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, rgba(34,211,238,0.18), rgba(124,58,237,0.22));\n  color: var(--portal-text);\n  font-weight: 800;\n  font-size: 13px;\n  letter-spacing: 0.2px;\n  /* visually attach badge to the card */\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.28);\n}\n\n.plan-card {\n  position: relative; /* ensure the selected badge can be absolutely positioned */\n}\n\n/* Strong focus ring for keyboard users */\n.plan-card:focus {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(124,58,237,0.18), 0 8px 20px rgba(0,0,0,0.25);\n  transform: translateY(-4px) scale(1.01);\n}\n\n/* mobile plan card selected visual parity */\n.mobile-plan-card.selected {\n  border-color: var(--portal-accent);\n  background: linear-gradient(180deg, rgba(124,58,237,0.06), rgba(34,211,238,0.04));\n  box-shadow: 0 12px 28px rgba(124,58,237,0.12);\n  transform: translateY(-4px);\n}\n\n.plan-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.plan-icon {\n  font-size: 32px;\n}\n\n.plan-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--portal-text);\n}\n\n.plan-price {\n  font-size: 48px;\n  font-weight: 900;\n  background: linear-gradient(135deg, #22d3ee 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 12px 0;\n}\n\n.plan-desc {\n  color: var(--portal-muted);\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.plan-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.plan-features li {\n  color: var(--portal-text);\n  padding: 8px 0;\n  font-size: 14px;\n}\n\n.btn-pay-metamask {\n  width: 100%;\n  background: linear-gradient(135deg, #f6851b 0%, #e2761b 100%);\n  color: #fff;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 30px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.btn-pay-metamask:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(246, 133, 27, 0.5);\n}\n\n.btn-pay-metamask:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.metamask-icon {\n  font-size: 24px;\n}\n\n.metamask-warning {\n  text-align: center;\n  color: var(--portal-warning);\n  font-size: 14px;\n  margin-top: 16px;\n}\n\n.metamask-warning a {\n  color: var(--portal-accent);\n  text-decoration: underline;\n}\n\n/* Payment History */\n.payment-history {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--portal-border);\n  border-radius: 16px;\n  padding: 24px;\n  margin: 24px 0;\n}\n\n.payment-history h4 {\n  margin: 0 0 20px;\n  color: var(--portal-text);\n  font-size: 18px;\n}\n\n.payment-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.payment-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: rgba(30, 41, 59, 0.7);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n  transition: all 0.2s ease;\n}\n\n.payment-item:hover {\n  border-color: var(--portal-primary);\n  transform: translateX(4px);\n}\n\n.payment-item-icon {\n  font-size: 24px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(34, 211, 238, 0.2);\n  border-radius: 50%;\n}\n\n.payment-item-details {\n  flex: 1;\n}\n\n.payment-item-amount {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--portal-success);\n}\n\n.payment-eth-amount {\n  font-size: 14px;\n  font-weight: 500;\n  color: #22d3ee;\n  margin-left: 8px;\n}\n\n.payment-item-plan {\n  color: var(--portal-muted);\n  font-size: 13px;\n  text-transform: capitalize;\n}\n\n.payment-item-date {\n  color: var(--portal-muted);\n  font-size: 12px;\n}\n\n.payment-item-link {\n  color: var(--portal-accent);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 12px;\n  background: rgba(34, 211, 238, 0.1);\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.payment-item-link:hover {\n  background: rgba(34, 211, 238, 0.2);\n}\n\n.payment-reminder-info {\n  background: rgba(124, 58, 237, 0.1);\n  border: 1px solid var(--portal-primary);\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 24px;\n}\n\n.payment-reminder-info h4 {\n  margin: 0 0 12px;\n  color: var(--portal-text);\n  font-size: 16px;\n}\n\n.payment-reminder-info p {\n  margin: 8px 0;\n  color: var(--portal-muted);\n  font-size: 14px;\n}\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(20px);\n  z-index: 60000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-content {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #1a1a2e 100%);\n  border: 2px solid rgba(124, 58, 237, 0.4);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(124, 58, 237, 0.3);\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 30px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 24px;\n  background: linear-gradient(135deg, #a855f7, #22d3ee);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.modal-close {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  color: #fff;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  background: rgba(239, 68, 68, 0.4);\n  transform: rotate(90deg);\n}\n\n.modal-body {\n  padding: 30px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px 30px;\n  border-top: 1px solid rgba(148, 163, 184, 0.2);\n}\n\n/* Edit Profile Modal */\n.edit-profile-modal .form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-field label {\n  color: var(--portal-accent);\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-field input,\n.form-field textarea {\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 10px;\n  padding: 12px 16px;\n  color: var(--portal-text);\n  font-size: 15px;\n  transition: all 0.2s ease;\n}\n\n.form-field input:focus,\n.form-field textarea:focus {\n  outline: none;\n  border-color: var(--portal-primary);\n  box-shadow: 0 0 20px rgba(124, 58, 237, 0.3);\n  transform: translateY(-2px);\n}\n\n.btn-cancel,\n.btn-save,\n.btn-pay {\n  padding: 12px 28px;\n  border-radius: 30px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n}\n\n.btn-cancel {\n  background: rgba(100, 116, 139, 0.2);\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  color: var(--portal-text);\n}\n\n.btn-cancel:hover {\n  background: rgba(100, 116, 139, 0.3);\n}\n\n.btn-save,\n.btn-pay {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n  color: #fff;\n}\n\n.btn-save:hover:not(:disabled),\n.btn-pay:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(34, 197, 94, 0.4);\n}\n\n.btn-save:disabled,\n.btn-pay:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Payment Modal */\n.payment-modal {\n  max-width: 500px;\n}\n\n.payment-confirmation {\n  text-align: center;\n}\n\n.payment-plan-summary {\n  margin-bottom: 30px;\n}\n\n.plan-icon-large {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.payment-plan-summary h4 {\n  margin: 0 0 12px;\n  color: var(--portal-text);\n  font-size: 22px;\n}\n\n.payment-amount-large {\n  font-size: 56px;\n  font-weight: 900;\n  background: linear-gradient(135deg, #22d3ee 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin: 16px 0;\n}\n\n.payment-desc {\n  color: var(--portal-muted);\n  font-size: 16px;\n}\n\n.payment-details-box {\n  background: rgba(15, 23, 42, 0.8);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 12px;\n  padding: 20px;\n  margin: 24px 0;\n  text-align: left;\n}\n\n.payment-detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  color: var(--portal-text);\n  font-size: 14px;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\n}\n\n.payment-detail-row:last-child {\n  border-bottom: none;\n}\n\n.payment-detail-row.total {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--portal-success);\n  padding-top: 16px;\n  margin-top: 8px;\n  border-top: 2px solid rgba(34, 211, 238, 0.3);\n}\n\n.payment-info {\n  margin: 24px 0;\n  text-align: left;\n}\n\n.payment-info p {\n  margin: 8px 0;\n  color: var(--portal-muted);\n  font-size: 14px;\n}\n\n.mono {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 13px;\n}\n\n/* Mobile responsiveness for modals */\n@media (max-width: 768px) {\n  .modal-content {\n    max-width: 95%;\n  }\n\n  .edit-profile-modal .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .plans-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .payment-amount-large {\n    font-size: 48px;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    padding: 20px;\n  }\n\n  .btn-pay-metamask {\n    font-size: 16px;\n    padding: 14px 24px;\n  }\n\n  .payment-amount-large {\n    font-size: 42px;\n  }\n}\n\n/* Technique badge shown above progress bars */\n.tech-badge {\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(255,215,0,0.12), rgba(255,255,255,0.02));\n  border: 1px solid rgba(255,215,0,0.18);\n  font-size: 12px;\n  line-height: 1;\n  color: #ffd700;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.35);\n}\n\n/* Floating wallet connect indicator */\n.wallet-floating {\n  position: fixed;\n  top: 18px;\n  right: 18px;\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 60001;\n  cursor: pointer;\n  border: 2px solid rgba(255,255,255,0.06);\n  background: rgba(6,8,15,0.6);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.wallet-floating:hover { transform: translateY(-3px); }\n\n.wallet-floating.connected { background: linear-gradient(135deg,#16a34a,#22c55e); box-shadow: 0 6px 20px rgba(34,197,94,0.18); color: white; }\n.wallet-floating.disconnected { background: linear-gradient(135deg,#ef4444,#f97316); box-shadow: 0 6px 20px rgba(239,68,68,0.14); color: white; }\n\n.wallet-floating .wf-icon { font-size: 18px; display: inline-block; }\n\n/* Make sure on small screens the floating icon isn't intrusive */\n@media (max-width: 480px) {\n  .wallet-floating { top: 12px; right: 12px; width: 40px; height: 40px; }\n}\n\n/* Mobile: place wallet indicator inside the portal container corner, smaller and touch-friendly */\n.student-portal-container.mobile-mode .wallet-floating {\n  position: absolute; /* positioned relative to container */\n  top: 10px;\n  right: 10px;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  padding: 2px;\n  background: rgba(0,0,0,0.35);\n  border: 1px solid rgba(255,255,255,0.04);\n  box-shadow: 0 6px 18px rgba(0,0,0,0.45);\n  z-index: 1200;\n}\n\n.student-portal-container.mobile-mode .wallet-floating.connected { background: linear-gradient(135deg,#10b981,#34d399); box-shadow: 0 6px 18px rgba(16,185,129,0.14); }\n.student-portal-container.mobile-mode .wallet-floating.disconnected { background: linear-gradient(135deg,#ef4444,#fb923c); box-shadow: 0 6px 18px rgba(239,68,68,0.12); }\n\n.student-portal-container.mobile-mode .wallet-floating .wf-icon { font-size: 14px; line-height: 1; }\n.student-portal-container.mobile-mode .wallet-floating:active { transform: translateY(0); }\n.student-portal-container.mobile-mode .wallet-floating { touch-action: manipulation; }\n\n/* Trophy area styles */\n.progress-bar {\n  height: 10px;\n  border-radius: 6px;\n  background: rgba(255,255,255,0.06);\n  margin-top: 6px;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  border-radius: 6px;\n  background: linear-gradient(90deg, var(--portal-primary), var(--portal-accent));\n}\n\n.attendance-progress .progress-bar-fill {\n  background: linear-gradient(90deg, var(--portal-warning), #ef4444);\n}\n\n.belt-attained-badge {\n  background: linear-gradient(90deg, var(--portal-warning), #ef4444);\n  /* use portal text for better contrast on dark/light themes */\n  color: var(--portal-text);\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-weight: 800;\n}\n\n/* Mobile-specific contrast overrides to avoid black text on bright gradients\n   Improves navigation legibility and small badges on mobile screens. */\n.student-portal-container.mobile-mode .payment-badge.payment-due,\n.student-portal-container.mobile-mode .belt-attained-badge,\n.student-portal-container.mobile-mode .trophy-chip .trophy-name,\n.student-portal-container.mobile-mode .trophy-chip .trophy-count,\n.student-portal-container.mobile-mode .mobile-bottom-bar,\n.student-portal-container.mobile-mode .mobile-bottom-bar * {\n  color: var(--portal-text) !important;\n  text-shadow: 0 1px 2px rgba(216, 214, 214, 0.6);\n}\n\n.student-portal-container.mobile-mode .mobile-header-actions,\n.student-portal-container.mobile-mode .mobile-header-actions * {\n  color: #fff !important;\n  text-shadow: 0 1px 2px rgba(197, 195, 195, 0.6);\n}\n\n/* Strong mobile-mode color reset: ensure no dark/black lettering appears\n   inside the student portal on small devices. This forces readable text\n   across gradients and light backgrounds used in mobile variants. */\n.student-portal-container.mobile-mode,\n.student-portal-container.mobile-mode * {\n  color: var(--portal-text) !important;\n}\n\n/* Keep interactive controls using their own explicit color rules */\n.student-portal-container.mobile-mode a,\n.student-portal-container.mobile-mode button,\n.student-portal-container.mobile-mode .btn-sm,\n.student-portal-container.mobile-mode .wallet-link-button {\n  color: inherit !important;\n}\n\n.trophy-header { display: flex; align-items: center; gap: 12px; }\n.trophy-header .trophy-title { font-weight: 800; font-size: 16px; color: var(--portal-text); }\n.trophy-header .trophy-sub { color: var(--portal-muted); font-size: 13px; }\n\n.mobile-pay-confirm .wallet-row .wallet-badge,\n.trophy-chip .trophy-name,\n.trophy-chip .trophy-count { color: var(--portal-text); }\n.trophy-area {\n  background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));\n  border: 1px solid rgba(148,163,184,0.06);\n  padding: 12px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(141, 141, 142, 0.35);\n}\n\n.trophy-list { display: flex; gap: 10px; align-items: center; }\n\n.trophy-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: rgba(15,23,42,0.6);\n  border: 1px solid rgba(255,255,255,0.02);\n}\n\n.trophy-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  background: linear-gradient(135deg, rgba(255,215,0,0.15), rgba(255,255,255,0.02));\n  color: #ffd700;\n  border: 1px solid rgba(255,215,0,0.12);\n  box-shadow: 0 6px 18px rgba(255,215,0,0.06);\n}\n\n.trophy-meta { display: flex; flex-direction: column; }\n.trophy-name { font-weight: 700; font-size: 13px; color: var(--portal-text); text-transform: capitalize; }\n.trophy-count { font-size: 12px; color: var(--portal-muted); }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
